import csc from 'country-state-city'

const PORTS = {
  C_ONE: 'https://prod-user.projectcentric.net', // user
  C_TWO: 'https://prod-task.projectcentric.net', // task
  C_THREE: 'https://prod-project.projectcentric.net', // project
}

const API_PORTS = {
  C_ONE_VERSION: `${PORTS.C_ONE}/v1`,
  C_TWO_VERSION: `${PORTS.C_TWO}/v1`,
  C_THREE_VERSION: `${PORTS.C_THREE}/v1`,
}

export const REACT_APP_API_URL = ''
const SKIP_PREFLIGHT_CHECK = true

const NODE_PATH = 'src'

export const BASE_URL = REACT_APP_API_URL

export const SENTRY_DSN =
  'https://95d01a97034a42ed8f6209fd16d05f7b@o272032.ingest.sentry.io/5396789'
export const SENTRY_PROJECT_NAME = 'ProjectCentric'
export const SENTRY_VERSION = '1.0.0'
export const SENTRY_TRACE_SAMPLE_RATE = 0.1314
export const SENTRY_ENV = 'Production'

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCn9drovA92HFnP6wzkywv3BkUc2yg51wE',
  authDomain: 'projectcentric-prod.firebaseapp.com',
  databaseURL: 'https://projectcentric-prod.firebaseio.com',
  projectId: 'projectcentric-prod',
  storageBucket: 'projectcentric-prod.appspot.com',
  messagingSenderId: '386840370224',
  appId: '1:386840370224:web:5ace0558c1f7874ed021f5',
  measurementId: 'G-3V6MBYW4Y3',
}

export const AWS_SETTINGS = {}

export const AWS_APPSYNC_SETTING = {
  aws_project_region: 'us-east-1',
  aws_appsync_graphqlEndpoint:
    'https://aienfifrp5dkjgareoxsb7pxiy.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'API_KEY',
  aws_appsync_apiKey: 'da2-h6tmro4wkbhwxjhytjdm32zlzu',
}
export const CRYPTO_KEY_EXPORT_ALL = 'PR@JECTCENTRIC1404' // customer created we used same in backend

export const CRYPTO_KEY = 'PR@JECTCENTRIC2018' // customer created we used same in backend
export const JOB_BOARD_PERMISSION = {
  JOB_BOARD: false, // Flag to hide jobboard
}
export const VALIDATION = {
  MIN_PHONE_NUMBER: 10,
  MAX_PHONE_NUMBER: 12,
  MIN_PASSWORD: 8,
  MAX_PASSWORD: 8,
  MIN_CHARACTER: 3,
  MAX_CHARACTER: 50,
  MIN_CUSTOMER: 1,
  MAX_CUSTOMER: 50,
  MAX_CITY: 25,
  MAX_BIO: 250,
  MAX_FIRST_NAME: 25,
  MAX_LAST_NAME: 25,
  MAX_TITLE: 25,
  MAX_PROJECT_NAME: 50,
  MAX_FOLDER_NAME: 50,
  MAX_PROJECT_MANDAYS_DESCRIPTION: 250,
  MAX_ROLE_DESCRIPTION: 250,
  MAX_ACTION_TITEL: 250,
  MAX_ACTION_DESCRIPTION: 750,
  MAX_RESELLER_DESCRIPTION: 500,
  MAX_KNOWLEDGE_BASE_ANSWER: 10000,
  MAX_NOTES_DESCRIPTION: 100000,
  MAX_PROJECT_FINAL_COMMENT: 512,
  MAX_COMMENT: 5000,
  MAX_TITLE_NAME: 255,
  MAX_TASK_NAME: 255,
  MAX_TASK_DESCRIPTION: 2500,
  MAX_ROLE_TITLE: 50,
  MAX_FAQ_FILE_SIZE: 5242880,
  MAX_QUESTION: 10000,
  MAX_ANSWER: 10000,
  MAX_ORG_DESCRIPTION: 250,
  DEFAULT_COUNTRY: csc.getCountryByCode('US'),
}

export const MAIN_TITLE_TEXT = {
  PORTAL_NAME: 'Organization',
}

export const MESSAGES = {
  EMAIL_VALIDATION: 'Please enter valid email!',
  EMAIL_REQUIRE: 'Please enter email!',
  VALID_TEXT_PATTARN: 'incorrect value inputted!',
  PASSWORD_REQUIRE: 'Please enter your password!',
  OLD_PASSWORD_REQUIRE: 'Please enter your old password!',
  COMPANY_NAME_REQUIRE: 'Please enter company name!',
  CITY_NAME_REQUIRE: 'Please enter city name!',
  PHONE_NUMBER_REQUIRE: 'Please enter phone number!',
  PHONE_NUMBER_VALIDATION: 'Please enter valid phone number!',
  COMPANY_BIO_REQUIRE: 'Please enter company bio!',
  USER_TITLE_REQUIRE: 'Please enter title!',
  USER_ROLE_REQUIRE: 'Please select permission!',
  USER_FULL_NAME_REQUIRE: 'Please enter fullname!',
  SUPER_ADMIN_STATUS_REQUIRE: 'Please select action!',
  NEW_PASSWORD_REQUIRE: 'Please enter your new password!',
  CONFIRM_PASSWORD_REQUIRE: 'Please enter your confirm password!',
  CONFIRM_PASSWORD_NOT_MATCH: "Password and confirm password doesn't match.",
  AT_MOST_ONE_FILE: 'Please select at most 1 file!',
  DATE_REQUIRE: 'Please select date!',
  FROM_LESS_THAN_TO: 'To date must be greater than start date!',
  COMPANY_NAME_REQUIRED: 'Please enter company name!',
  FIRST_NAME_REQUIRED: 'Please enter first name!',
  LAST_NAME_REQUIRED: 'Please enter last name!',
  AT_LEAST_ONE_FILTER: 'Please select at least one option to apply filter.',

  AT_LEAST_ONE_FILTER_RESELLER:
    'Please select at least option to update the Reseller(s).',
  AT_LEAST_ONE_FILTER_REVENUE:
    'Please select at least option to update the Revenue(s).',
  AT_LEAST_ONE_VALUE: 'Please use at least one field!',
  PROJECT_NAME_REQUIRE: 'Please enter project name!',
  CUSTOMER_REQUIRE: 'Please select customer!',
  MEDIACENTRIC_OWNER_REQUIRE: `Please select ${MAIN_TITLE_TEXT?.PORTAL_NAME} owner!`,
  CUSTOMER_OWNER_REQUIRE: 'Please select customer owner!',
  START_LESS_THAN_END: 'End date must be greater than start date!',
  CHECK_ONE_CHECKBOX: 'Please select atleast one Checkbox!',
  END_DATE_REQUIRE: 'Please enter end date!',
  DUE_DATE_REQUIRE: 'Please enter due date!',
  START_DATE_REQUIRE: 'Please enter start date!',
  AT_LEAST_ONE_SPACE: 'Please enter at least one space!',
  AT_LEAST_ONE_MEMBER: 'Please select at least one member!',
  ADDRRESS_LINE_ONE_REQUIRE: 'Please enter your address!',
  CITY_REQUIRE: 'Please enter city name!',
  STATE_REQUIRE: 'Please select state!',
  COUNTRY_REQUIRE: 'Please select country!',
  SPACE_TAG_AT_MOST_ONE: 'Please select at most one space tag!',
  SPACE_NAME_REQUIRED: 'Please enter space name',
  IMAGE_UPLOAD_INFO: 'You can only upload JPG/PNG file!',
  DOCS_UPLOAD_INFO: "You can only upload doc's file!",
  IS_IMAGE_UPLOAD_INFO: 'You can only upload JPG/JPEG/PNG file!',
  IMAGE_VALIDATION: 'Image must smaller than 2MB!',
  AT_LEAST_ONE_GROUP_FOLDER_NAME_REQUIRE:
    'Please add at least one group folder name!',
  AT_LEAST_ONE_GROUP_NAME_REQUIRE: 'Please add at least one group name!',
  GROUP_NAME_REQUIRE: 'Please enter group name!',
  TASK_NAME_REQUIRE: 'Please enter task name!',
  AT_LEAST_ONE_MEMBER_OR_ROLE:
    'Please select at least one team member or role!',
  EQUIPMENT_MODEL_NAME_REQUIRE: 'Please enter device name!',
  ACTION_TITLE_REQUIRE: 'Please enter action title!',
  ACTION_PRIORITY_REQUIRE: 'Please select priority!',
  ACTION_SPACE_REQUIRE: 'Please select space!',
  ACTION_USER_REQUIRE: 'Please select at least one user!',
  TAG_NAME_REQUIRE: 'Please Enter Tag Name!',
  COMMENT_REQUIRE: 'Please write something!',
  COMMENT_PRIORITY_REQUIRE: 'Please select priority!',
  AT_LEAST_ONE_DOCUMENT: 'At least one document is required!',
  UPLOAD_FILE: 'Document is required!',
  SPACE_TEMPLATE_TITLE_REQUIRE: 'Please enter space template title!',
  PASSWORD_MIN: 'Password must contain at least 8 characters!',
  PASSWORD_MAX: 'Password must contain at most 8 characters!',
  CUSTOMER_MIN: 'Name must contain at least 1 characters!',
  CUSTOMER_MAX: 'This should not exceed than 50 characters!',
  NAME_MIN: 'Name must contain at least 3 characters!',
  CITY_MAX: 'City must contain at most 25 characters!',
  BIO_MAX: 'Bio must contain at most 250 characters!',
  FIRST_NAME_MAX: 'This should not exceed than 25 characters!',
  LAST_NAME_MAX: 'This should not exceed than 25 characters!',
  TITLE_MAX: 'Title must contain at most 25 characters!',
  ONLY_ALPHABETS: 'Only alphabets are allowed!',
  ONLY_NAME_PATTARN: 'Please enter valid name!',
  VALID_CITY: 'Please enter valid city name!',
  PROJECT_NAME_MAX: 'This should not exceed than 50 characters!',
  PROJECT_MANDAYS_DESC_MAX:
    'Budgeted Days description must contain at most 250 characters!',
  PROJECT_FINAL_MAX:
    'Project final comment must contain at most 512 characters!',
  TASK_FINAL_COMMENT_REQUIRE: 'Please enter the comment!',
  ROLE_DESC_MAX: 'Role description must contain at most 250 characters!',
  ACTION_ITEM_TITEL_MAX: 'Title must contain at most 250 characters!',
  INTERNAL_NOTE_DESC_MAX: 'Description must contain at most 100000 characters!',
  ACTION_ITEM_DESC_MAX_LIMIT:
    'Description must contain at most 750 characters!',
  KNOWLEDGE_BASE_QUESTION_MAX_LIMIT:
    'Question must contain at most 10000 characters!',
  KNOWLEDGE_BASE_ANSWER_MAX_LIMIT:
    'Answer must contain at most 10000 characters!',
  RESELLER_DESC_MAX_LIMIT: 'Description must contain at most 500 characters!',
  COMMENT_MAX: `Comment must contain at most ${VALIDATION?.MAX_COMMENT} characters!`,
  NOTE_MAX: `Note must contain at most ${VALIDATION?.MAX_COMMENT} characters!`,
  EQUIPMENT_SERIAL_NUMBER: 'Please enter serial number!',
  TASK_TEMPLATE_TITLE_REQUIRE: 'Please enter task template title!',
  TASK_NAME_MAX: 'Task name must contain at most 255 characters limit!',
  TASK_DESCRIPTION_MAX:
    'Task description must contain at most 2500 characters!',
  TASK_GROUP_REQUIRE: 'Please select task group!',
  TASK_REASON_REQUIRE: 'Please enter canceled task reason!',
  ROLE_TITLE_REQUIRE: 'Please enter role title!',
  ROLE_TYPE_REQUIRE: 'Please select role type!',
  ROLE_TITLE_MAX: 'Role title must contain at most 50 characters!',
  PERMISSION_TITLE_REQUIRE: 'Please enter Permission title!',
  PERMISSION_TYPE_REQUIRE: 'Please select Permission type!',
  PERMISSION_TITLE_MAX: 'Permission title must contain at most 50 characters!',
  FEEDBACK_REASON_REQUIRE: 'Please select reason!',
  FEEDBACK_ENTER_REASON_REQUIRE: 'Please enter reason!',
  AT_LEAST_ONE_REVIEW: 'Please select at least one question to submit review!',
  FILE_TYPE_REQUIRE: 'Please select file type!',
  TASK_TYPE_NAME_REQUIRE: 'Please enter task type name!',
  TASK_SUB_TYPE_NAME_REQUIRE: 'Please enter task sub type name!',
  AT_LEAST_ONE_LOWER_CASE:
    'Password must contain at least one lowercase character!',
  AT_LEAST_ONE_UPPER_CASE:
    'Password must contain at least one uppercase character!',
  AT_LEAST_ONE_DIGIT: 'Password must contain at least one digit!',
  AT_LEAST_ONE_SPECIAL_CHARACTER:
    'Password must contain at least one special character!',
  EMAIL_ALREADY_TAKEN: 'Email address is already taken!',
  EMAIL_ALREADY_ENTERED: 'Email address is already taken in the form!',
  ORG_ALREADY_TAKEN: 'Organization name is already taken!',
  LINE_ITEM_TAKEN: 'Line Item name already exists',
  COMPANY_NAME_TAKEN: 'Company name already exists',
  PROJECT_ALREADY_TAKEN: 'Project name is already taken!',
  PHONE_NUMBER_MIN: 'minimum 10 characters are required!',
  PHONE_NUMBER_MAX: 'maximum 12 characters are allowed!',
  EMAIL_AT_MOST_ONE: 'Please select/enter at most one email!',
  EXPORT_CATEGORY_REQUIRE: 'Please select at least 1 item!',
  FOLDER_NAME_REQUIRE: 'Please enter folder name!',
  FOLDER_NAME_MAX: 'maximum 50 characters are allowed!',
  FOLDER_NAME_PATTARN: 'Please enter valid name!',
  NAME_WITHOUT_SPACE_PATTARN: 'Please enter valid name!',
  FAQ_CATEGORY_REQUIRE: 'Please enter category!',
  FAQ_FILE_SIZE_MAX:
    'You can add video/image here and it should be less then 50MB.',
  HEADER_TITLE_REQUIRE: 'Please enter title!',
  HEADER_DESCRIPTION_REQUIRE: 'Please enter description!',
  QUESTION_NAME_REQUIRE: 'Please enter question!',
  ANSWER_NAME_REQUIRE: 'Please enter answer!',
  QUESTION_NAME_MAX: `maximum ${VALIDATION?.MAX_QUESTION} characters are allowed!`,
  ANSWER_NAME_MAX: `maximum ${VALIDATION?.MAX_ANSWER} characters are allowed!`,
  ORGANIZATION_NAME_REQUIRE: 'Please enter organization name!',
  ORGANIZATION_MIN: `Name must contain at least ${VALIDATION?.MIN_CHARACTER} characters!`,
  ORGANIZATION_MAX: `This should not exceed than ${VALIDATION?.MAX_CHARACTER} characters!`,
  TC_REQUIRE: 'Please select Terms & Conditions!',
  TIME_ZONE_REQUIRE: 'Please select time zone!',
  ORG_DESC_MAX: 'Organization description must contain at most 250 characters!',
  SUBSCRIPTION_PLAN_REQUIRE: 'Please select subscription plan!',
  DISCOUNT_REQUIRED: 'Please enter discount!',
  LEAD_REQUIRED: 'Please select lead.',
}

export const API_ENDPOINTS = {
  LOGIN: `${API_PORTS.C_ONE_VERSION}/auth/signin`,
  RESET_PASSWORD_REQUEST: `${API_PORTS.C_ONE_VERSION}/auth/forgot-password`,
  RESENT_PASSWORD_MAIL: `${API_PORTS.C_ONE_VERSION}/user/sendInitialUserPasswordMail`,
  VERIFY_PASSWORD_REQUEST: `${API_PORTS.C_ONE_VERSION}/auth/reset-password`,
  VERIFY_INVITED_USER: `${API_PORTS.C_ONE_VERSION}/auth/acceptInvitation`,
  CUSTOMERS_LIST: `${API_PORTS.C_ONE_VERSION}/customer/listCustomer`,
  CUSTOMERS_USERS_LIST: `${API_PORTS.C_ONE_VERSION}/user/getCustomerUsers`,
  CUSTOMERS_USERS_EXPORT: `${API_PORTS.C_ONE_VERSION}/user/exportCustomerUsers`,
  CHANGE_PASSWORD_REQUEST: `${API_PORTS.C_ONE_VERSION}/auth/change-password`,
  CUSTOMER_BY_ID: `${API_PORTS.C_ONE_VERSION}/customer/getCustomerById`,
  DELETE_CUSTOMER: `${API_PORTS.C_ONE_VERSION}/customer/deleteCustomer`,
  UPDATE_CUSTOMER: `${API_PORTS.C_ONE_VERSION}/customer/updateCustomer`,
  ADD_CUSTOMER: `${API_PORTS.C_ONE_VERSION}/customer/addCustomer`,
  ADD_USER: `${API_PORTS.C_ONE_VERSION}/user/addUser`,
  GET_NOTIFICATIONS_LIST: `${API_PORTS.C_ONE_VERSION}/user/getMyNotification`,
  ALL_ROLES: `${API_PORTS.C_ONE_VERSION}/role/listRole`,
  DELETE_USER: `${API_PORTS.C_ONE_VERSION}/user/deleteUser`,
  SET_USER_STATUS: `${API_PORTS.C_ONE_VERSION}/user/setActiveStatus`,
  USER_BY_ID: `${API_PORTS.C_ONE_VERSION}/user/getUserById`,
  UPDATE_USER: `${API_PORTS.C_ONE_VERSION}/user/updateUser`,
  BULK_USER: `${API_PORTS.C_ONE_VERSION}/user/addBulkUser`,
  UPDATE_PROFILE: `${API_PORTS.C_ONE_VERSION}/user/updateMyProfile`,
  ANTIVIRUS_SCANNER_STATUS: `${API_PORTS.C_ONE_VERSION}/antivirus/avStatus`,
  ANTIVIRUS_SCANNER: `${API_PORTS.C_ONE_VERSION}/antivirus/avScannerOnOff`,
  CUSTOMER_DROPDOWN: `${API_PORTS.C_ONE_VERSION}/customer/customersList`,
  CUSTOMER_USER_LIST: `${API_PORTS.C_ONE_VERSION}/customer/custumersUserList`,
  MEDIACENTRIC_USER_LIST: `${API_PORTS.C_ONE_VERSION}/user/mediaCentricUser`,
  ADD_MEDIACENTRIC_USERS: `${API_PORTS.C_ONE_VERSION}/user/addMediaCentricUser`,
  DROP_DOWN_NEW_MEDIACENTRIC_USER_LIST: `${API_PORTS.C_ONE_VERSION}/user/mediaCentricUserList`,
  ADD_BULK_MEDIACENTRIC_USERS: `${API_PORTS.C_ONE_VERSION}/user/addBulkMediaCentricUser`,
  UPDATE_MEDIACENTRIC_USER: `${API_PORTS.C_ONE_VERSION}/user/updateMediaCentricUser`,
  DELETE_MEDIACENTRIC_USER: `${API_PORTS.C_ONE_VERSION}/user/deleteMediaCentricUser`,
  EXPORT_MEDIACENTRIC_USERS: `${API_PORTS.C_ONE_VERSION}/user/exportUsers`,
  CHECK_EMAIL: `${API_PORTS.C_ONE_VERSION}/user/checkEmailExists`,
  GET_MY_PROFILE: `${API_PORTS.C_ONE_VERSION}/user/getMyProfile`,
  I_AM_ONLINE: `${API_PORTS.C_ONE_VERSION}/online/iAmOnline`,
  MEDIACENTRIC_USERS: `${API_PORTS.C_ONE_VERSION}/user/listUser`,
  MEDIACENTRIC_USERS_ROLES: `${API_PORTS.C_ONE_VERSION}/role/listMediaCentricRole`,
  CUSTOMER_ROLES_LIST: `${API_PORTS.C_ONE_VERSION}/role/listRole`,
  GET_PROJECT_ROLES: `${API_PORTS.C_ONE_VERSION}/projectRole/listProjectRole`,
  GET_CUSTOMER_ATTTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/getCustomerAttachment`,
  POST_CUSTOMER_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/addCustomerAttachment`,
  ADD_PROJECT_DIRECTORY: `${API_PORTS.C_ONE_VERSION}/attachment/createProjectDirectory`,
  UPDATE_PROJECT_DIRECTORY: `${API_PORTS.C_ONE_VERSION}/attachment/updateProjectDirectory`,
  DELETE_PROJECT_FOLDERS: `${API_PORTS.C_ONE_VERSION}/attachment/deleteProjectDirectory`,
  DELETE_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/deleteAttachment`,
  GET_PROJECT_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/getProjectAttachment`,
  ADD_PROJECT_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/addProjectAttachment`,
  MOVE_PROJECT_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/updateProjectAttachment`,
  EXPORT_MULTIPLE_FOLDERS_TO_ZIP: `${API_PORTS.C_ONE_VERSION}/attachment/exportMultipleFoldersToZip`,
  EXPORT_MULTIPLE_FILES_TO_ZIP: `${API_PORTS.C_ONE_VERSION}/attachment/exportMultipleFilesToZip`,
  GET_PROJECT_DAILY_REPORT_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/getDailyReports`,
  SEND_DAILY_REPORT_ATTACHMENTS_TO_MAIL: `${API_PORTS.C_ONE_VERSION}/attachment/sendReportPdfMail`,
  SPACE_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/getSpaceAttachment`,
  ADD_TASK_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/addTaskAttachment`,
  ADD_PROJECT_NOTE_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/addProjectNoteAttachment`,
  ROTATE_IMAGE: `${API_PORTS.C_ONE_VERSION}/attachment/rotateImageAndSave`,
  GET_PERMISSIONS: `${API_PORTS.C_ONE_VERSION}/role/getMyPermissions`,
  GET_MEDIACENTRIC_ROLES: `${API_PORTS.C_ONE_VERSION}/role/getMediaCentricRoles`,
  GET_CUSTOMER_ROLES: `${API_PORTS.C_ONE_VERSION}/role/getCustomerRoles`,
  GET_ROLE_BASED_PERMISSIONS: `${API_PORTS.C_ONE_VERSION}/role/getOperationPermission`,
  DELETE_ROLE: `${API_PORTS.C_ONE_VERSION}/role/deleteRole`,
  ADD_ROLE: `${API_PORTS.C_ONE_VERSION}/role/addRole`,
  ADD_ROLE_WITH_PERMISSIONS: `${API_PORTS.C_ONE_VERSION}/role/addRoleWithPermission`,
  UPDATE_ROLE: `${API_PORTS.C_ONE_VERSION}/role/updateRole`,
  ADD_PROJECT_ROLE: `${API_PORTS.C_ONE_VERSION}/projectRole/addProjectRole`,
  UPDATE_PROJECT_ROLE: `${API_PORTS.C_ONE_VERSION}/projectRole/updateProjectRole`,
  DELETE_PROJECT_ROLE: `${API_PORTS.C_ONE_VERSION}/projectRole/deleteProjectRole`,
  CUSTOMER_STATUS: `${API_PORTS.C_ONE_VERSION}/customer/setActiveStatus`,
  EXPORT_DATA: `${API_PORTS.C_ONE_VERSION}/customer/exportCustomers`,
  CUSTOMER_SHORT_DETAILS: `${API_PORTS.C_ONE_VERSION}/customer/getCustomerShortDetails`,
  ROLE_CHANGE: `${API_PORTS.C_ONE_VERSION}/role/changeOperationPermission`,
  ROLE_CHANGE_BY_OP: `${API_PORTS.C_ONE_VERSION}/role/updateRolePermission`,
  ROLE_LIST_OPERATIONS: `${API_PORTS.C_ONE_VERSION}/role/listOperation`,
  UPDATE_ONSITE_LEAD: `${API_PORTS.C_ONE_VERSION}/role/updateOnsiteLeadPermissionForBudget`,
  GET_ONSITE_LEAD: `${API_PORTS.C_ONE_VERSION}/role/getOnsiteLeadPermissionForBudget`,
  ADD_FAQ_CATEGORY: `${API_PORTS.C_ONE_VERSION}/faq/addFaqCategory`,
  UPDATE_FAQ_CATEGORY: `${API_PORTS.C_ONE_VERSION}/faq/updateFaqCategory`,
  DELETE_FAQ_CATEGORY: `${API_PORTS.C_ONE_VERSION}/faq/deleteFaqCategory`,
  GET_FAQ_CATEGORY: `${API_PORTS.C_ONE_VERSION}/faq/FaqQuestionCategoryList`,
  REORDER_FAQ_CATEGORY: `${API_PORTS.C_ONE_VERSION}/faq/reorderFaqCategory`,
  GET_FAQ_LIST: `${API_PORTS.C_ONE_VERSION}/faq/listFaq`,
  Add_FAQ_QUESTIONS_AND_HEADER: `${API_PORTS.C_ONE_VERSION}/faq/addFaq`,
  UPDATE_FAQ_QUESTIONS_AND_HEADER: `${API_PORTS.C_ONE_VERSION}/faq/updateFaq`,
  DELETE_FAQ_QUESTIONS_AND_HEADER: `${API_PORTS.C_ONE_VERSION}/faq/deleteFaq`,
  REORDER_FAQ_QUESTIONS: `${API_PORTS.C_ONE_VERSION}/faq/reorderFaq`,
  DELETE_FAQ_ATTACHMENT: `${API_PORTS.C_ONE_VERSION}/faq/deleteFile`,
  RESEND_INVITATION: `${API_PORTS.C_ONE_VERSION}/user/resendInviteEmail`,

  // Organization
  GET_ORG_LIST: `${API_PORTS.C_ONE_VERSION}/organization/listOrganization`,
  EXPORT_ORG_LIST: `${API_PORTS.C_ONE_VERSION}/organization/exportOrganizations`,
  ADD_ORG: `${API_PORTS.C_ONE_VERSION}/organization/addOrganization`,
  UPDATE_ORG: `${API_PORTS.C_ONE_VERSION}/organization/updateOrganization`,
  UPDATE_MY_ORG: `${API_PORTS.C_ONE_VERSION}/organization/updateMyOrganization`,
  STATUS_CHANGE_ORG: `${API_PORTS.C_ONE_VERSION}/organization/changeOrganizationStatus`,
  DELETE_ORG: `${API_PORTS.C_ONE_VERSION}/organization/deleteOrganization`,
  GET_ORG_BY_ID: `${API_PORTS.C_ONE_VERSION}/organization/getOrganizationById`,
  SET_MY_ORG: `${API_PORTS.C_ONE_VERSION}/auth/setOrganazation`,
  GET_MY_ORG: `${API_PORTS.C_ONE_VERSION}/organization/getMyOrganization`,
  CHECK_EXIST_ORG: `${API_PORTS.C_ONE_VERSION}/organization/checkOrganizationNameExists`,
  GET_PLATFORM_USERS: `${API_PORTS.C_ONE_VERSION}/user/listPlatformUsers`,
  EXPORT_PLATFORM_USERS: `${API_PORTS.C_ONE_VERSION}/user/exportPlatformUsers`,
  DELETE_USER_BY_PLATFORM_USER: `${API_PORTS.C_ONE_VERSION}/organization/deleteUserByPlatformOwner`,
  DELETE_USER_BY_PLATFORM_USER_WITH_ORG: `${API_PORTS.C_ONE_VERSION}/user/deleteUserInOrgByPlatformOwner`,
  GET_MII_USERS: `${API_PORTS.C_ONE_VERSION}/user/listAllUsers`,
  EXPORT_MII_USERS: `${API_PORTS.C_ONE_VERSION}/user/exportAllUsers`,
  GET_USERS_BY_MII_USER_ID: `${API_PORTS.C_ONE_VERSION}/user/getUserByIdInAllOrgByPlatformOwner`,
  UPDATE_MII_USER_BY_ID: `${API_PORTS.C_ONE_VERSION}/user/updateEmailByPlatformOwner`,
  GET_SAPERATE_USER_BY_MII_USER_ID: `${API_PORTS.C_ONE_VERSION}/user/getUserByIdInOrgByPltOwner`,
  UPDATE_MII_USER_DETAILS_BY_ID: `${API_PORTS.C_ONE_VERSION}/user/updateUserInfoByPlatformOwner`,
  UPDATE_MII_USER_STATUS_BY_ID: `${API_PORTS.C_ONE_VERSION}/user/changeStatusByPlatformOwner`,
  UPER_ADMIN_CREATE_CHANGE: `${API_PORTS.C_ONE_VERSION}/organization/changeUser`,
  DISCOUNT_CLEAR: `${API_PORTS.C_ONE_VERSION}/organization/clearDiscount`,
  CHECK_EMAIL_EXISTS_FOR_ORG: `${API_PORTS.C_ONE_VERSION}/organization/checkEmailExistsForOrg`,

  // Subscription
  GET_USAGE_BY_ORG_ID: `${API_PORTS.C_ONE_VERSION}/subscription/subscriptionPlanUses`,
  UPDATE_SUBSCRIPTION_PLAN: `${API_PORTS.C_ONE_VERSION}/subscription/changeSubscriptionPlan`,
  GET_SUBSCRIPTION_PLANS_LIST: `${API_PORTS.C_ONE_VERSION}/subscription/listSubscriptionPlan`,
  GET_SUBSCRIPTION_CURRENT_PLAN: `${API_PORTS.C_ONE_VERSION}/organization/getAmountAndDiscountInfo`,
  CANCEL_SUBSCRIPTION: `${API_PORTS.C_ONE_VERSION}/subscription/cancelPlanRequest`,
  DELETE_CANCEL_SUBSCRIPTION_REQ: `${API_PORTS.C_ONE_VERSION}/subscription/deleteCancelPlanRequest`,
  GET_PAYMENT_HISTORY: `${API_PORTS.C_ONE_VERSION}/organization/organizationPaymentHistory`,
  UPDATE_USERS_IN_SUBSCRIPTION: `${API_PORTS.C_ONE_VERSION}/subscription/addUsersIntoCurrentPlan`,
  GET_ALL_ORG_PAYMENT_SUBSCRIPTION: `${API_PORTS.C_ONE_VERSION}/organization/allOrganizationPaymentSubscription`,
  EXPORT_ALL_ORG_PAYMENT_SUBSCRIPTION: `${API_PORTS.C_ONE_VERSION}/organization/exportPaymentSubscription`,
  GET_WIZARD_DETAILS: `${API_PORTS.C_ONE_VERSION}/organization/getWizardDetails`,
  SET_TERMS_ACCEPTED: `${API_PORTS.C_ONE_VERSION}/organization/setTermsAccepted`,
  SET_TERMS_ACCEPTED_FOR_ALL: `${API_PORTS.C_ONE_VERSION}/user/setTermsAcceptedForAll`,
  UPDATE_ORGANIZATION_TIME_ZONE: `${API_PORTS.C_ONE_VERSION}/organization/updateOrganizationSchedule`,
  SET_ON_BOARDING_STATUS: `${API_PORTS.C_ONE_VERSION}/organization/setOnboardingStatus`,
  ADD_CARDS: `${API_PORTS.C_ONE_VERSION}/payment/addCard`,
  GENERATE_CLIENT_TOKEN_BRAINTREE: `${API_PORTS.C_ONE_VERSION}/payment/intializeBraintree`,
  DOWNLOAD_TC_FILE: `${API_PORTS.C_ONE_VERSION}/organization/downloadTermCondition`,
  SUBSCRIPTION_ORDER_SUMMARY: `${API_PORTS.C_ONE_VERSION}/organization/orderSummary`,
  GET_ALL_MY_CARDS: `${API_PORTS.C_ONE_VERSION}/payment/getMyCards`,
  SET_DEFAULT_CARD: `${API_PORTS.C_ONE_VERSION}/payment/setCardDefault`,
  MANUAL_SUBSCRIPTION: `${API_PORTS.C_ONE_VERSION}/subscription/manualSubscription`,

  // Dropdown
  GET_DROPDOWN_PROJECT_ROLE: `${API_PORTS.C_ONE_VERSION}/projectRole/listDropdownProjectRole`,
  GET_DROPDOWN_MY_ORG_LIST: `${API_PORTS.C_ONE_VERSION}/organization/listAllMyOrganization`,
  GET_DROPDOWN_ORG_USER_LIST: `${API_PORTS.C_ONE_VERSION}/organization/listUserOrganizaionDropdown`,
  GET_DROPDOWN_ORG_OWNER: `${API_PORTS.C_ONE_VERSION}/organization/listOwnerDropdown`,
  GET_DROPDOWN_SUBSCRIPTION_PLAN: `${API_PORTS.C_ONE_VERSION}/organization/subscriptionPlanDropdown`,
  GET_DROPDOWN_SP_SYSTEM_ROLE: `${API_PORTS.C_ONE_VERSION}/user/dropdownSuperUserSystemRole`,
  GET_DROPDOWN_SP_ROLE_BY_USER_TYPE: `${API_PORTS.C_ONE_VERSION}/role/listRoleForPlatformOwner`,
  GET_DROPDOWN_ALL_USERS_SYSTEM_ROLE: `${API_PORTS.C_ONE_VERSION}/user/dropdownAllUserSystemRole`,
  GET_DROPDOWN_USERS_BY_ORG_ID: `${API_PORTS.C_ONE_VERSION}/user/getUsersByOrgId`,
  GET_DROPDOWN_ALL_CUSTOMER: `${API_PORTS.C_ONE_VERSION}/organization/allCustomerDropdown`,
  GET_DROPDOWN_ALL_ORGANIZATION: `${API_PORTS.C_ONE_VERSION}/organization/listOrganizationDropdown`,

  GET_ALL_PROJECTS: `${API_PORTS.C_THREE_VERSION}/project/listProject`,
  EXPORT_ALL_PROJECTS: `${API_PORTS.C_THREE_VERSION}/project/exportProjectAll`,
  GET_MY_PROJECTS: `${API_PORTS.C_THREE_VERSION}/project/myProject`,
  ALL_PROJECTS_FOR_DROPDOWN: `${API_PORTS.C_THREE_VERSION}/project/listDropdownProject`,
  PROJECT_STATUES: `${API_PORTS.C_THREE_VERSION}/project/listProjectStatus `,
  PROJECT_TAGS: `${API_PORTS.C_THREE_VERSION}/project/listProjectTag`,
  PROJECT_SHORT_DETAILS: `${API_PORTS.C_THREE_VERSION}/project/getProjectShortDetails`,
  ADD_PROJECTS: `${API_PORTS.C_THREE_VERSION}/project/addProject`,
  DELETE_PROJECT: `${API_PORTS.C_THREE_VERSION}/project/deleteProject`,
  GET_PROJECT_BY_ID: `${API_PORTS.C_THREE_VERSION}/project/getProjectById`,
  UPDATE_PROJECT: `${API_PORTS.C_THREE_VERSION}/project/updateProject`,
  UPDATE_SEND_REPORT: `${API_PORTS.C_THREE_VERSION}/project/updateSendReport`,
  CHECK_PROJECT_IS_EXIST: `${API_PORTS.C_THREE_VERSION}/project/checkProjectExists`,
  ADD_TEAM: `${API_PORTS.C_THREE_VERSION}/project/addTeam`,
  GET_TEAM: `${API_PORTS.C_THREE_VERSION}/project/listTeam`,
  UPDATE_USER_PROJECT_ROLE: `${API_PORTS.C_THREE_VERSION}/project/updateUserProjectRole`,
  DACTIVATE_PROJECT: `${API_PORTS.C_THREE_VERSION}/project/deactivateProject`,
  CUSTOMER_VS_PROJECT: `${API_PORTS.C_THREE_VERSION}/dashboard/customerVsProject`,
  PROJECT_VS_RESOURCES: `${API_PORTS.C_THREE_VERSION}/dashboard/projectsVsResources`,
  HOME_ACTION_ITEMS: `${API_PORTS.C_THREE_VERSION}/dashboard/dasboardListActionItems`,
  PROJECTS_BY_USER: `${API_PORTS.C_THREE_VERSION}/dashboard/dashboardProjectsByUser`,
  PROJECTS_READINES_REPORT: `${API_PORTS.C_THREE_VERSION}/dashboard/dashboardProjectReadinessReport`,
  PROJECTS_READINES_REPORT_EXPORT: `${API_PORTS.C_THREE_VERSION}/dashboard/exportDashboardProjectReadinessReport`,
  PROJECTS_BY_CUSTOMER_USER: `${API_PORTS.C_THREE_VERSION}/dashboard/customerProjectsByUser`,
  CUSTOMER_PROJECT_STATS_COUNT: `${API_PORTS.C_THREE_VERSION}/dashboard/customerProjectsStatusCount`,
  GET_ALL_CUST_PROJECTS: `${API_PORTS.C_THREE_VERSION}/dashboard/customerListProjects`,
  HOME_PROJECT_STATS_COUNT: `${API_PORTS.C_THREE_VERSION}/dashboard/dashboardProjectsStatusCount`,
  HOME_COUNTRY_GRAPH: `${API_PORTS.C_THREE_VERSION}/dashboard/projectCountryCount`,
  HOME_BAR_GRAPH: `${API_PORTS.C_THREE_VERSION}/dashboard/monthWiseCompletedProjectCount`,
  HOME_TOP_ORGANIZATIN: `${API_PORTS.C_THREE_VERSION}/dashboard/topOrganizationByProjectCount`,
  HOME_OSS_PROJECT_COMMENT: `${API_PORTS.C_THREE_VERSION}/dashboard/dasboardListOutOfScopeComment`,
  HOME_OSS_PROJECT_COMMENT_EXPORT: `${API_PORTS.C_THREE_VERSION}/dashboard/exportDasboardListOutOfScopeComment`,
  HOME_REPORT_DASHBOARD_WIDGET: `${API_PORTS.C_THREE_VERSION}/dashboard/projectBudgetLineItemReport`,
  REPORT_BUDGET_EXPORT: `${API_PORTS.C_THREE_VERSION}/dashboard/exportProjectBudgetLineItemReport`,
  ADD_SPACE: `${API_PORTS.C_THREE_VERSION}/space/addSpace`,
  ADD_BULK_SPACE: `${API_PORTS.C_THREE_VERSION}/space/bulkAddSpace`,
  GET_SPACE: `${API_PORTS.C_THREE_VERSION}/space/listSpace`,
  GET_SPACE_TAGS: `${API_PORTS.C_THREE_VERSION}/space/listTag`,
  DELETE_SPACE: `${API_PORTS.C_THREE_VERSION}/space/deleteSpace`,
  UPDATE_SPACE: `${API_PORTS.C_THREE_VERSION}/space/updateSpace`,
  UPDATE_BULK_SPACE: `${API_PORTS.C_THREE_VERSION}/space/bulkUpdateSpaces`,
  UPDATE_BULK_POP_UP_SPACE: `${API_PORTS.C_THREE_VERSION}/space/bulkPopUpUpdateSpaces`,
  DUPLICTE_SPACE: `${API_PORTS.C_THREE_VERSION}/space/bulkDuplicateSpaces`,
  DELETE_BULK_SPACE: `${API_PORTS.C_THREE_VERSION}/space/bulkDeleteSpaces`,
  REORDER_SPACE: `${API_PORTS.C_THREE_VERSION}/space/reorderSpace`,
  ADD_TAG: `${API_PORTS.C_THREE_VERSION}/space/addTag`,
  GET_EQUIPMENTS: `${API_PORTS.C_THREE_VERSION}/space/listSpaceDevice`,
  DELETE_EQUIPMENT: `${API_PORTS.C_THREE_VERSION}/space/deleteSpaceDevice`,
  ADD_EQUIPMENT: `${API_PORTS.C_THREE_VERSION}/space/addSpaceDevice`,
  UPDATE_EQUIPMENT: `${API_PORTS.C_THREE_VERSION}/space/updateSpaceDevice`,
  EXPORT_EQUIPMENT: `${API_PORTS.C_THREE_VERSION}/space/exportSpaceDevices`,
  GET_ACTION_ITEMS: `${API_PORTS.C_THREE_VERSION}/project/actionItem/listActionItem`,
  GET_ACTION_ITEMS_PRIORITY: `${API_PORTS.C_THREE_VERSION}/project/actionItem/listActionPriority`,
  GET_ACTION_ITEMS_STATUS: `${API_PORTS.C_THREE_VERSION}/project/actionItem/listActionStatus`,
  ADD_ACTION_ITEM: `${API_PORTS.C_THREE_VERSION}/project/actionItem/addActionWithAttachment`,
  DELETE_ACTION_ITEM: `${API_PORTS.C_THREE_VERSION}/project/actionItem/deleteActionItem`,
  UPDATE_ACTION_ITEM: `${API_PORTS.C_THREE_VERSION}/project/actionItem/updateActionItem`,
  CHANGE_ACTION_ITEM_STATUS: `${API_PORTS.C_THREE_VERSION}/project/actionItem/changeStatus`,
  GET_ACTION_ITEM_BY_ID: `${API_PORTS.C_THREE_VERSION}/project/actionItem/getActionItemById`,
  ADD_ACTION_ATTACHMENTS: `${API_PORTS.C_ONE_VERSION}/attachment/addActionAttachment`,
  GET_COMMENTS: `${API_PORTS.C_THREE_VERSION}/project/comment/listComment`,
  GET_COMMENTS_PRIORITY: `${API_PORTS.C_THREE_VERSION}/project/comment/listCommentPriority`,
  ADD_COMMENT: `${API_PORTS.C_THREE_VERSION}/project/comment/addComment`,
  DELETE_COMMENT: `${API_PORTS.C_THREE_VERSION}/project/comment/deleteComment`,
  UPDATE_COMMENT: `${API_PORTS.C_THREE_VERSION}/project/comment/updateComment`,
  GET_COMMENTS_BY_ID: `${API_PORTS.C_THREE_VERSION}/project/comment/getProjectCommentById`,
  GET_NOTES: `${API_PORTS.C_THREE_VERSION}/project/note/listNote`,
  ADD_NOTE: `${API_PORTS.C_THREE_VERSION}/project/note/addNote`,
  GET_NOTES_BY_ID: `${API_PORTS.C_THREE_VERSION}/project/note/getProjectNoteById`,
  DELETE_NOTE: `${API_PORTS.C_THREE_VERSION}/project/note/deleteNote`,
  UPDATE_NOTE: `${API_PORTS.C_THREE_VERSION}/project/note/updateNote`,
  DELETE_TEAM_MEMBER: `${API_PORTS.C_THREE_VERSION}/project/removeTeam`,
  ASSIGN_TEAM_MEMBERS: `${API_PORTS.C_THREE_VERSION}/project/addTeam`,
  ASSIGN_TEAM_MEMBERS_AS_ONSITE_LEAD: `${API_PORTS.C_THREE_VERSION}/project/changeOnSiteLead`,
  GET_REMAING_USERS_FOR_PROJECT: `${API_PORTS.C_THREE_VERSION}/project/remainingTeam`,
  EXCLUDED_MEDIACENTRIC_USERS: `${API_PORTS.C_THREE_VERSION}/project/excludedMediaCentricUser`,
  EXCLUDED_CUSTOMER_USERS: `${API_PORTS.C_THREE_VERSION}/project/excludedCustomerUser`,
  PROJECT_FEEDBACK: `${API_PORTS.C_THREE_VERSION}/project/listFeedback`,
  ADD_FEEDBACK: `${API_PORTS.C_THREE_VERSION}/project/submitFeedback`,
  EXPORT_COMMENTS: `${API_PORTS.C_THREE_VERSION}/project/comment/exportComments`,
  EXPORT_NOTES: `${API_PORTS.C_THREE_VERSION}/project/note/exportNotes`,
  EXPORT_PROJECTS: `${API_PORTS.C_THREE_VERSION}/project/exportProjects`,
  EXPORT_SPACES: `${API_PORTS.C_THREE_VERSION}/space/exportSpaceTaskListAndDevices`,
  EXPORT_PROJECTS_TEAM: `${API_PORTS.C_THREE_VERSION}/project/exportProjectTeam`,
  EXPORT_ACTION_ITEMS: `${API_PORTS.C_THREE_VERSION}/project/actionItem/exportActionItem`,
  EXPORT_ALL_DOWNLOAD: `${API_PORTS.C_THREE_VERSION}/project/exportAllLinks`,
  REPORTING_FEEDBACK: `${API_PORTS.C_THREE_VERSION}/project/reportListFeedback`,
  REPORTING_FEEDBACK_EXPORT_DATA: `${API_PORTS.C_THREE_VERSION}/project/exportReportListFeedback`,
  REPORTING_PROJECT_TIMELINE: `${API_PORTS.C_THREE_VERSION}/reporting/listProjectTimeline`,
  REPORTING_PROJECT_TIMELINE_EXPORT_DATA: `${API_PORTS.C_THREE_VERSION}/reporting/exportProjectTimeline`,
  REPORTING_ACTION_ITEMS: `${API_PORTS.C_THREE_VERSION}/reporting/listReportActionItem`,
  REPORTING_ACTION_ITEMS_EXPORT_DATA: `${API_PORTS.C_THREE_VERSION}/reporting/exportReportActionItem`,
  REPORTING_SYNC: `${API_PORTS.C_THREE_VERSION}/reporting/listUserSyncReport`,
  REPORTING_NOTIFICATION: `${API_PORTS.C_THREE_VERSION}/reporting/listNotificationReport`,
  REPORTING_NOTIFICATION_EXPORT_DATA: `${API_PORTS.C_THREE_VERSION}/reporting/exportNotificationReport`,
  REPORTING_SYNC_EXPORT_DATA: `${API_PORTS.C_THREE_VERSION}/reporting/exportUserSyncReport`,
  REPORTING_ALL_PROJECT_LEAD: `${API_PORTS.C_THREE_VERSION}/reporting/listAllProjectLeadReport`,
  REPORTING_ALL_PROJECT_LEAD_EXPORT_DATA: `${API_PORTS.C_THREE_VERSION}/reporting/exportAllProjectLeadReport`,
  REPORTING_PROJECT_LEAD_DETAILS: `${API_PORTS.C_THREE_VERSION}/reporting/listProjectLeadReportById`,
  REPORTING_PROJECT_LEAD_DETAILS_EXPORT_DATA: `${API_PORTS.C_THREE_VERSION}/reporting/exportProjectLeadReportById`,
  REPORTING_ONSITE_LEAD_ANALYTICS_BY_ID: `${API_PORTS.C_THREE_VERSION}/reporting/getOnsiteLeadAnalyticsById`,

  TASK_STATUS_COUNT: `${API_PORTS.C_THREE_VERSION}/dashboard/projectTaskStatusCount`,
  TASK_GROUP_DATA: `${API_PORTS.C_THREE_VERSION}/dashboard/projectTaskGroupWiseData`,
  PROJECT_RESOURCES: `${API_PORTS.C_THREE_VERSION}/dashboard/projectResourceAllocation`,
  PROJECT_INSTALLATION_IMAGES: `${API_PORTS.C_THREE_VERSION}/dashboard/projectInstallationImages`,
  PROJECT_ACTION_ITEM_INSTALLATION_IMAGES: `${API_PORTS.C_THREE_VERSION}/dashboard/projectActionItemImages`,
  PROJECT_DASHBOARD_ALL_TAKS: `${API_PORTS.C_THREE_VERSION}/dashboard/projectAllTasks`,
  PROJECT_DASHBOARD_ALL_TAKS_EXPORT: `${API_PORTS.C_THREE_VERSION}/dashboard/exportProjectAllTasks`,
  PROJECT_DASHBOARD_SNAPSHOT_REPORT_EXPORT: `${API_PORTS.C_THREE_VERSION}/reporting/exportProjectSnapshotReport`,
  CUSTOMER_DASHBOARD_ACTION_ITEMS: `${API_PORTS.C_THREE_VERSION}/dashboard/customerListOpenActionItems`,

  GET_SPACE_LIST_DROPDOWN: `${API_PORTS.C_THREE_VERSION}/project/listDropdownSpace`,
  GET_DROPDOWN_TASK_GROUPS_LIST: `${API_PORTS.C_THREE_VERSION}/project/listDropdownTaskGroup`,
  GET_DROPDOWN_TASK_ASSIGNED: `${API_PORTS.C_THREE_VERSION}/project/listDropdownTaskAssigned`,
  GET_DROPDOWN_ONSITE_LEAD: `${API_PORTS.C_THREE_VERSION}/dashboard/listDropdownProjectOnSiteLeads`,
  GET_DROPDONW_CUSTOMER_OWNER: `${API_PORTS.C_THREE_VERSION}/dashboard/listDropdownProjectCustomerOwner`,
  GET_DROPDONW_NOTIFICATION_USER: `${API_PORTS.C_THREE_VERSION}/project/listDropdownNotificationUsers`,
  GET_DROPDONW_NOTIFICATION_TYPE: `${API_PORTS.C_THREE_VERSION}/project/listDropdownNotificationType`,

  IMPORT_PROJECT_FROM_FILE: `${API_PORTS.C_THREE_VERSION}/import/importProjectsFromFile`,
  IMPORT_SPACE_WITH_TASK_FILE: `${API_PORTS.C_THREE_VERSION}/import/importSpaceWithTasksFromFile`,
  IMPORT_USERS_FROM_FILE: `${API_PORTS.C_ONE_VERSION}/import/importUsersFromFile`,
  IMPORT_CUSTOMERS_WITH_USERS_FROM_FILE: `${API_PORTS.C_ONE_VERSION}/import/importCustomersWithUserFromFile`,
  IMPORT_TASKS_FROM_FILE: `${API_PORTS.C_TWO_VERSION}/import/importTasksFromFile`,
  IMPORT_TASKS_TEMP_FROM_FILE: `${API_PORTS.C_TWO_VERSION}/import/importTaskTemplateFromFile`,
  IMPORT_SPACE_TEMP_FROM_FILE: `${API_PORTS.C_TWO_VERSION}/import/importSpaceTemplateFromFile`,
  IMPORT_SPACE_TEMP_WITH_EQUIPMENT: `${API_PORTS.C_THREE_VERSION}/import/importSpaceWithEquipmentFromFile`,
  IMPORT_CONFIG_BUDGET_FROM_FILE: `${API_PORTS.C_ONE_VERSION}/import/importConfigLineItemFromFile`,
  IMPORT_EQUIPMENT_FROM_FILE: `${API_PORTS.C_THREE_VERSION}/import/importEquipmentFromFile`,

  GET_DROPDOWN_TASKGROUP_FOLDER: `${API_PORTS.C_TWO_VERSION}/task/listTaskGroupFolderDropDown`,
  GET_TASK_GROUPS: `${API_PORTS.C_TWO_VERSION}/task/listGroupCount`,
  GET_TASK_GROUPS_LIST: `${API_PORTS.C_TWO_VERSION}/task/listTaskGroup`,
  GET_TASK_GROUPS_LIST_ADMIN: `${API_PORTS.C_TWO_VERSION}/task/listTaskGroupAdmin`,
  GET_DROPDOWN_TASK_TEMP_FOLDER: `${API_PORTS.C_TWO_VERSION}/task/listDropDownTaskTemplateFolder`,
  GET_ALL_TASK_TEMPLATES_DROPDOWN: `${API_PORTS.C_TWO_VERSION}/template/listTaskTemplateDropdown`,
  GET_DROPDOWN_SPACE_TEMP_FOLDER: `${API_PORTS.C_TWO_VERSION}/template/listSpaceTemplateFolderDropdown`,
  GET_DROPDOWN_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/listSpaceTemplateDropdown`,
  GET_TASK_FOR_MULTIPLE_SPACE: `${API_PORTS.C_TWO_VERSION}/task/dropdownTaskListBySpaces`,

  FOLDER_TASK_GROUP: `${API_PORTS.C_TWO_VERSION}/task/listTaskGroupFolderAdmin`,
  FOLDER_ADD_TASK_GROUP: `${API_PORTS.C_TWO_VERSION}/task/addTaskGroupFolder`,
  FOLDER_UPDATE_TASK_GROUP: `${API_PORTS.C_TWO_VERSION}/task/updateTaskGroupFolder`,
  FOLDER_DELETE_TASK_GROUP: `${API_PORTS.C_TWO_VERSION}/task/deleteTaskGroupFolder`,
  ADD_TASK_GROUPS: `${API_PORTS.C_TWO_VERSION}/task/addTaskGroup`,
  UPDATE_TASK_GROUPS: `${API_PORTS.C_TWO_VERSION}/task/updateTaskGroup`,
  DELETE_TASK_GROUPS: `${API_PORTS.C_TWO_VERSION}/task/deleteTaskGroup`,
  FOLDER_TASK_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/listTaskTemplateFolder`,
  FOLDER_ADD_TASK_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/addTaskTemplateFolder`,
  FOLDER_UPDATE_TASK_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/updateTaskTemplateFolder`,
  FOLDER_DELETE_TASK_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/deleteTaskTemplateFolder`,
  ADD_TASK_TYPE: `${API_PORTS.C_TWO_VERSION}/task/addTaskType`,
  GET_TASKS: `${API_PORTS.C_TWO_VERSION}/task/listTask`,
  ADD_TASK: `${API_PORTS.C_TWO_VERSION}/task/addTask`,
  DELETE_TASK: `${API_PORTS.C_TWO_VERSION}/task/deleteTask`,
  TASK_STATUS_CHANGE: `${API_PORTS.C_TWO_VERSION}/task/changeStatus`,
  UPDATE_TASK: `${API_PORTS.C_TWO_VERSION}/task/updateTask`,
  REORDER_TASK: `${API_PORTS.C_TWO_VERSION}/task/reorderTask`,
  EXPORT_TASK: `${API_PORTS.C_TWO_VERSION}/task/exportTask`,
  GET_TASK_BY_ID: `${API_PORTS.C_TWO_VERSION}/task/getTaskById`,
  GET_TASK_TYPES: `${API_PORTS.C_TWO_VERSION}/task/listTaskType`,
  GET_TASK_TYPES_ADMIN: `${API_PORTS.C_TWO_VERSION}/task/listTaskTypeAdmin`,
  UPDATE_TASK_TYPES: `${API_PORTS.C_TWO_VERSION}/task/updateTaskType`,
  DELETE_TASK_TYPES: `${API_PORTS.C_TWO_VERSION}/task/deleteTaskType`,
  GET_TASK_SUB_TYPES: `${API_PORTS.C_TWO_VERSION}/task/listTaskSubType`,
  GET_TASK_SUB_TYPES_ADMIN: `${API_PORTS.C_TWO_VERSION}/task/listTaskSubTypeAdmin`,
  ADD_TASK_SUB_TYPES: `${API_PORTS.C_TWO_VERSION}/task/addSubTaskType`,
  UPDATE_TASK_SUB_TYPES: `${API_PORTS.C_TWO_VERSION}/task/updateTaskSubType`,
  DELETE_TASK_SUB_TYPES: `${API_PORTS.C_TWO_VERSION}/task/deleteTaskSubType`,
  BULK_TASK_UPDATE: `${API_PORTS.C_TWO_VERSION}/task/bulkUpdateSelectedTask`,
  BULK_TASK_DELETE: `${API_PORTS.C_TWO_VERSION}/task/bulkDeleteSelectedTask`,
  ADD_TASK_GROUPS_IN_SPACE: `${API_PORTS.C_TWO_VERSION}/task/bulkAddTaskGroupInSpace`,
  DELETE_TASK_GROUP_IN_SPACE: `${API_PORTS.C_TWO_VERSION}/task/deleteTaskGroupInSpace`,
  GET_ALL_TASK_TEMPLATES: `${API_PORTS.C_TWO_VERSION}/template/listTaskTemplate`,
  ASSIGN_TASK: `${API_PORTS.C_TWO_VERSION}/task/assignTask`,
  GET_ALL_TASK_STATUSES: `${API_PORTS.C_TWO_VERSION}/task/listStatus`,
  REORDER_TASK_GROUPS: `${API_PORTS.C_TWO_VERSION}/task/reorderTaskGroupInSpace`,
  FOLDER_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/listSpaceTemplateFolder`,
  ADD_FOLDER_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/addSpaceTemplateFolder`,
  UPDATE_FOLDER_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/updateSpaceTemplateFolder`,
  DELETE_FOLDER_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/deleteSpaceTemplateFolder`,
  ADD_SPACE_TEMPLATE_EXISTING_SPACE: `${API_PORTS.C_TWO_VERSION}/template/importSpaceTemplatesInSpace`,
  COPY_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/createSpaceTemplateFromSpace`,
  ADD_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/addSpaceTemplate`,
  DELETE_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/deleteSpaceTemplate`,
  EDIT_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/updateSpaceTemplate`,
  SPACE_TEMPLATE_TASKS: `${API_PORTS.C_TWO_VERSION}/template/listTaskTemplate`,
  ADD_TASK_TO_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/addTaskTemplate`,
  UPDATE_TASK_TO_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/updateTaskTemplate`,
  DELETE_TASK_TO_SPACE_TEMPLATE: `${API_PORTS.C_TWO_VERSION}/template/deleteTaskTemplate`,
  SPACE_TEMPLATES_LIST: `${API_PORTS.C_TWO_VERSION}/template/listSpaceTemplate`,
  SPACE_TEMPLATES_LIST_EXPORT: `${API_PORTS.C_TWO_VERSION}/template/exportSpaceTemplate`,
  IMPORT_SPACE_TEMPLATES: `${API_PORTS.C_TWO_VERSION}/template/listSpaceTemplate`,
  CREATE_SPACE_WITH_TEMPLATES: `${API_PORTS.C_TWO_VERSION}/template/importSpaceTemplates`,
  GET_GROUP_BASE_TASK_TEMPLATES: `${API_PORTS.C_TWO_VERSION}/template/groupBasedTaskTemplates`,
  ADD_DEVICE_TOKEN: `${API_PORTS.C_TWO_VERSION}/deviceInfo/updateDeviceToken`,
  DELETE_DEVICE_TOKEN: `${API_PORTS.C_TWO_VERSION}/deviceInfo/removeDeviceToken`,
  __GET_ALL_TASKS: `${API_PORTS.C_TWO_VERSION}/template/listTaskTemplate`,
  __GET_ALL_TASKS_EXPORT: `${API_PORTS.C_TWO_VERSION}/template/exportTaskTemplate`,

  LIST_LINE_ITEM: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/listLineItem`,
  SUB_PLAN_DETAILS: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/subPlanDetails`,
  ADD_LINE_ITEM: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/bulkAddLineItem`,
  UPDATE_LINE_ITEM: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/updateLineItem`,
  DELETE_LINE_ITEM: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/deleteLineItem`,
  BULK_DELETE_LINE_ITEM: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/bulkDeleteLineItems`,
  GET_LINE_ITEM_BY_ID: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/getLineItemById`,
  EXPORT_LINE_ITEM: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/exportBudgetLineItems`,
  GET_LINE_ITEM_DROPDOWN: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/getLineItemDropdown`,
  CHECK_LINE_ITEM_EXISTS: `${API_PORTS.C_ONE_VERSION}/budgetLineItem/checkLineItemNameExists`,

  LIST_PROJECT_LINE_ITEM: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/listProjectBudgetLineItem`,
  ADD_PROJECT_LINE_ITEM: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/bulkAddProjectBudgetLineItem`,
  UPDATE_PROJECT_LINE_ITEM: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/updateProjectBudgetLineItem`,
  GET_PROJECT_LINE_BY_ID: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/getProjectBudgetLineItemById`,
  DELETE_PROJECT_LINE: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/deleteProjectBudgetLineItem`,
  BULK_DELETE_PROJECT_LINE: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/bulkDeleteProjectBudgetLineItems`,
  EXPORT_PROJECT_LINE: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/exportProjectBudgetLineItem`,
  GET_PROJECT_COLORS: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/getProjectBudgetColours`,
  SEND_BULK_BUDGET_NOTIFICATION: `${API_PORTS.C_THREE_VERSION}/projectBudgetLineItem/sendBulkEditNotifications`,

  LIST_SPACE_TAG: `${API_PORTS.C_THREE_VERSION}/space/listSpaceTagConfig`,
  DELETE_SPACE_TAG: `${API_PORTS.C_THREE_VERSION}/space/deleteSpaceTagConfig`,
  UPDATE_SPACE_TAG: `${API_PORTS.C_THREE_VERSION}/space/updateSpaceTagConfig`,
  ADD_SPACE_TAG: `${API_PORTS.C_THREE_VERSION}/space/addSpaceTagConfig`,
  EXPORT_SPACE_TAG: `${API_PORTS.C_THREE_VERSION}/space/exportSpaceTagConfig`,
  BULK_DELETE_SPACE_TAG: `${API_PORTS.C_THREE_VERSION}/space/bulkDeleteSpaceTagConfig`,

  LIST_PROJECT_TAG: `${API_PORTS.C_THREE_VERSION}/project/listProjectTagConfig`,
  ADD_PROJECT_TAG: `${API_PORTS.C_THREE_VERSION}/project/addProjectTagConfig`,
  UPDATE_PROJECT_TAG: `${API_PORTS.C_THREE_VERSION}/project/updateProjectTagConfig`,
  DELETE_PROJECT_TAG: `${API_PORTS.C_THREE_VERSION}/project/deleteProjectTagConfig`,
  EXPORT_PROJECT_TAG: `${API_PORTS.C_THREE_VERSION}/project/exportProjectTagConfig`,
  BULK_DELETE_PROJECT_TAG: `${API_PORTS.C_THREE_VERSION}/project/bulkDeleteProjectTagConfig`,

  ADD_RESELLER: `${API_PORTS.C_ONE_VERSION}/organization/addReseller`,
  EDIT_RESELLER: `${API_PORTS.C_ONE_VERSION}/organization/editReseller`,
  GET_RESELLER_BY_ID: `${API_PORTS.C_ONE_VERSION}/organization/getResellerById`,
  DELETE_RESELLER: `${API_PORTS.C_ONE_VERSION}/organization/deleteReseller`,
  STATUS_TOGGLE_RESELLER: `${API_PORTS.C_ONE_VERSION}/organization/statusToggleReseller`,
  GET_RESELLER_DROPDOWN: `${API_PORTS.C_ONE_VERSION}/organization/getResellerDropDown`,
  GET_RESELLER_DATA: `${API_PORTS.C_ONE_VERSION}/organization/listReseller`,
  EXPORT_RESELLER: `${API_PORTS.C_ONE_VERSION}/organization/exportReseller`,
  CHECK_COMPANY_NAME_EXIST: `${API_PORTS.C_ONE_VERSION}/organization/checkCompanyNameExists`,

  COUNTRY_WIDGET_RESELLER: `${API_PORTS.C_THREE_VERSION}/dashboard/organizationCountryCount`,
  TOP_ORG_WIDGET_RESELLER: `${API_PORTS.C_ONE_VERSION}/organization/topOrganizationOfReseller`,

  CHECK_IF_PROJECT_TAG_EXIST: `${API_PORTS.C_THREE_VERSION}/project/checkIfProjectTagExists`,
  CHECK_IF_SPACE_TAG_EXIST: `${API_PORTS.C_THREE_VERSION}/space/checkIfSpaceTagExists`,
  GET_PROJECT_TAG_BY_IDS: `${API_PORTS.C_THREE_VERSION}/project/getProjectTagNamesByIds`,
  GET_SPACE_TAG_BY_IDS: `${API_PORTS.C_THREE_VERSION}/space/getSpaceTagNamesByIds`,
  BULK_MERGE_PROJECT_TAG: `${API_PORTS.C_THREE_VERSION}/project/bulkMergeProjectTagConfig`,
  BULK_MERGE_SPACE_TAG: `${API_PORTS.C_THREE_VERSION}/space/bulkMergeSpaceTagConfig`,

  EXTEND_NEXT_BILLING_DATE: `${API_PORTS.C_ONE_VERSION}/subscription/extendSubscription`,
}

export const API_RESPONSE_MESSAGES = {
  UPDATE_CUSTOMER: 'Customer has been successfully updated.',
  DELETE_CUSTOMER: 'Customer has been successfully deleted.',
  ADD_CUSTOMER: 'Customer has been successfully created.',
  ADD_USERS: 'User(s) have been successfully added.',
  REMOVE_USER: 'User have been successfully remove.',
  PASSWORD_CHANGE: 'Password has been successfully changed.',
  PASSWORD_SEND: 'Password has been successfully sent.',
  UPDATE_USER: 'User has been successfully updated.',
  ADD_PROJECT: 'Project has been successfully created.',
  DEACTIVATE_PROJECT: 'Project has been successfully deactivated',
  PROJECT_SENT_DAILY_REPORT: 'Daily report have been successfully sent.',
  CHANGE_REPORT_READY_TO_SEND: 'Daily report has been successfully updated.',
  ADD_SPACES: 'Space(s) have been successfully added in projects',
  ADD_TEAMS: 'Team has been successfully assigned to the project.',
  DELETE_PROJECT: 'Project has been successfully deleted.',
  DELETE_SPACE: 'Space has been successfully deleted.',
  UPDATE_SPACE: 'Space has been successfully updated.',
  UPDATE_PROJECT: 'Project has been successfully updated.',
  MEDIACENTRIC_USER_ADD: 'User(s) have been successfully created.',
  MEDIACENTRIC_USER_UPDATE: 'User have been successfully updated.',
  MEDIACENTRIC_USER_DELETE: 'User have been successfully deleted.',
  CHANGE_TO_SUPER_ADMIN: 'Super admin have been successfully changed.',
  PROFILE_UPDATE: 'Your profile has been successfully updated.',
  ADD_TASK_GROUP: 'Task group have been successfully created.',
  DELETE_TASK: 'Task has been successfully deleted.',
  ADD_TASK: 'Task has been successfully added.',
  BULK_TASK_UPDATE: 'Task(s) has been successfully updated.',
  BULK_TASK_DELETE: 'Task(s) has been successfully deleted.',
  UPDATE_TASK: 'Task has been successfully updated.',
  REORDER_TASK: 'Task(s) have been successfully reordered.',
  REORDER_SPACE: 'Space(s) have been successfully reordered.',
  REORDER_TASK_GROUPS: 'Task Group(s) have been successfully reordered.',
  ADD_TASK_GROUPS_IN_SPACE:
    'Task Group(s) have been successfully added in the space.',
  DELETE_TASK_GROUPS_IN_SPACE:
    'Task Group(s) have been successfully deleted in the space.',
  ASSIGN_TASK: 'Task has been successfully assigned.',
  ASSIGN_ONSITE_LEAD: 'Onsite Lead has been successfully updated.',
  UPDATE_TASK_STATUS: 'Task status has been successfully updated.',
  ADD_EQUIPMENT: 'Equipment has been successfully added.',
  DELETE_EQUIPMENT: 'Equipment has been successfully deleted.',
  UPDATE_EQUIPMENT: 'Equipment has been successfully updated.',
  ACTION_ITEM_ADD: 'Action item has been successfully added.',
  DELETE_ACTION_ITEM: 'Action item has been successfully deleted.',
  UPDATE_ACTION_ITEM: 'Action item has been successfully updated.',
  ACTION_ITEM_SPACE: 'Space has been successfully updated for action item.',
  COMMENT_ADD: 'Comment has been successfully added.',
  DELETE_COMMENT: 'Comment has been successfully deleted.',
  UPDATE_COMMENT: 'Comment has been successfully updated.',
  ADD_NOTE: 'Note has been successfully added.',
  DELETE_NOTE: 'Note has been successfully deleted.',
  UPDATE_NOTE: 'Note has been successfully updated.',
  DELETE_TEAM_MEMBER:
    'Team member has been successfully removed from this project.',
  ASSIGN_TEAM_MEMBER:
    'Team member(s) have been successfully assigned to this project.',
  UPDATE_USER_PROJECT_ROLE:
    'Project role has been successfully updated for user.',
  ADD_FOLDER: 'Folder have been successfully added.',
  UPDATE_FOLDER: 'Folder have been successfully update.',
  MOVE_DOCUMENTS: 'Attachment has been successfully move.',
  ASSIGN_DOCUMENTS: 'Document(s) have been successfully uploaded.',
  DELETE_DOCUMENTS: 'Document has been successfully deleted.',
  ADD_SPACE_TEMPLATE: 'Space template has been successfully created.',
  DELETE_SPACE_TEMPLATE: 'Space template has been successfully deleted.',
  MOVE_SPACE_TEMPLATE: 'Space template has been successfully move.',
  EDIT_SPACE_TEMPLATE: 'Space template has been successfully updated.',
  TASK_ADDED_SPACE_TEMPLATE:
    'Task has been successfully added in space template.',
  TASK_UPDATED_SPACE_TEMPLATE:
    'Task has been successfully updated in space template.',
  TASK_DELETED_SPACE_TEMPLATE:
    'Task has been successfully deleted in space template.',
  TASK_TEMPLATE_DELETED: 'Task template has been successfully deleted.',
  TASK_TEMPLATE_UPDATED: 'Task template has been successfully updated.',
  TASK_TEMPLATE_ADDED: 'Task template has been successfully added.',
  TASK_TEMPLATE_MOVE: 'Task template has been successfully move.',
  ACTIVE_CUSTOMER: 'Customer has been made active.',
  DEACTIVE_CUSTOMER: 'Customer has been made inactive.',
  ACTIVE_USER: 'User has been successfully activated.',
  DEACTIVE_USER: 'User has been successfully deactivated.',
  USER_ROLE: 'User permission has been successfully updated.',
  PERMISSION_UPDATE: 'Permission(s) have been successfully updated.',
  ROLE_ADDED: 'Role has been successfully added.',
  ROLE_UPDATED: 'Role has been successfully updated.',
  ROLE_DELETED: 'Role has been successfully deleted.',
  PERMISSION_ADDED: 'Permission has been successfully added.',
  PERMISSION_UPDATED: 'Permission has been successfully updated.',
  PERMISSION_DELETED: 'Permission has been successfully deleted.',
  PROJECT_ROLE_ADDED: 'Project role has been successfully added.',
  PROJECT_ROLE_UPDATED: 'Project role has been successfully updated.',
  PROJECT_ROLE_DELETED: 'Project role has been successfully deleted.',
  REVIEW_SAVED: 'Feedback has been successfully saved.',
  ACTION_ITEM_STATUS_UPDATE:
    'Action item status has been successfully updated.',
  TASK_GROUP_ADD: 'New group has been successfully added.',
  TASK_GROUP_UPDATE: 'Group Name has been successfully updated.',
  TASK_GROUP_DELETE: 'Task group has been successfully deleted.',
  TASK_GROUP_MOVE: 'Task group has been successfully move.',
  TASK_TYPE_ADD: 'Task type has been successfully added.',
  TASK_TYPE_UPDATE: 'Task type has been successfully updated.',
  TASK_TYPE_DELETE: 'Task type has been successfully deleted.',
  TASK_SUB_TYPE_ADD: 'Task sub type has been successfully added.',
  TASK_SUB_TYPE_UPDATE: 'Task sub type has been successfully updated.',
  TASK_SUB_TYPE_DELETE: 'Task sub type has been successfully deleted.',
  EMAIL_REDIRECT:
    'You will be logged out, please login with your new password.',
  IMAGE_UPLOAD_ADD: 'New Image has been successfully added.',
  FAQ_HEADER_ADD: 'Knowledge base header has been successfully added.',
  FAQ_HEADER_UPDATE: 'Knowledge base header has been successfully update.',
  FAQ_CATEGORY_ADD: 'Knowledge base category has been successfully added.',
  FAQ_CATEGORY_UPDATE: 'Knowledge base category has been successfully update.',
  FAQ_CATEGORY_DELETE: 'Knowledge base category has been successfully deleted.',
  REORDER_CATEGORY:
    'Knowledge base category(s) have been successfully reordered.',
  FAQ_QUESTION_ADD: 'Knowledge base question has been successfully added.',
  FAQ_QUESTION_UPDATE: 'Knowledge base question has been successfully update.',
  FAQ_QUESTION_DELETE: 'Knowledge base question has been successfully deleted.',
  REORDER_FAQ_QUESTIONS:
    'Knowledge base question(s) have been successfully reordered.',
  FILE_DOCUMENTS: 'File have been successfully uploaded.',
  IMPORT_FILE_DOCUMENTS: 'Import Process is successful.',
  IMAGE_FILE: 'File have been successfully deleted.',
  ADD_ORGANIZATION: 'Organization has been successfully created.',
  UPDATE_ORGANIZATION: 'Organization has been successfully update.',
  UPDATE_ORGANIZATION_DISCOUNT: 'Discount has been successfully update.',
  REMOVE_ORGANIZATION: 'Organization have been successfully remove.',
  UPDATE_MII_USER_EMAIL: 'Email has been successfully updated.',
  UPDATE_USER_IN_PLAN: 'Users has been successfully updated.',
  UPDATE_PLAN: 'Subscription has been successfully updated.',
  CANCEL_USER_IN_PLAN: 'Subscription has been successfully canceled.',
  CANCEL_REQ_DELETE_IN_PLAN:
    'Subscription cancel request has been successfully Removed.',
  INVITATION_SENT: 'Invitation has been successfully sent.',
  UPDATE_LEAD: 'Lead has been successfully updated.',
  ADD_LEAD: 'Lead has been successfully added.',
  MOVE_JOB: 'Job has been successfully moved.',
  COPY_JOB: 'Job(s) has been successfully copied.',
  REMOVE_JOB: 'Job has been successfully removed.',
  ADD_JOB: 'Job has been successfully added.',
  LINE_ITEM_ADD: 'Line item has been successfully added.',
  DELETE_LINE_ITEM: 'Line item has been successfully deleted.',
  UPDATE_LINE_ITEM: 'Line item has been successfully updated.',
  BULK_DELETE_LINE_ITEM: 'Line items has been successfully deleted.',
  SELECT_BULK_DELETE_LINE_ITEM: 'Please select Line Item to delete.',
  SELECT_SPACE_EXPORT: 'Please select a Space to Export.',
  SELECT_BULK_DELETE_TAGS: 'Please select a tag to delete.',
  BULK_DELETE_TAGS: 'Tags has been successfully deleted.',
  ATTACHMENT_UPLOAD: 'Attachment has been uploaded',
  ADD_TAG: 'Tag has been Added',
  UPDATE_TAG: 'Tag has been Updated',
  DELETE_TAG: 'Tag has been Deleted',
  MERGE_TAG: 'Tags have been merged.',
  ADD_RESELLER: ' Reseller has been successfully added.',
  UPDATE_RESELLER: ' Reseller has been successfully updated.',
  DELETE_RESELLER: ' Reseller has been successfully deleted.',
  ACTIVATE_RESELLER: ' Reseller has been successfully activated.',
  DEACTIVATE_RESELLER: ' Reseller has been successfully deactivated.',
  DELETE_DAILY_REPORT: 'Daily Status Report has been successfully deleted.',
  EXTEND_BILLING_DATE: 'Next billing date has been successfully updated.',
}

export const STATIC_USABLE_TEXT = {
  ORGANIZATION_TEXT: 'Organisation',
  FEATURE: 'Feature',
  USERS: 'user',
  PROJECTS: 'projects',
  CUSTOMER_USER: 'customer users',
  CONFIG_ROLE: 'system roles',
  PROJECT_ROLE: 'project roles',
}
export const STATIC_ALERT = {
  PROJECT_LIMIT_EXPIRES:
    'Your Organisation has reached the total allowed number of projects. Please contact Administrator for further help.',
  USER_LIMIT_EXPIRES:
    'Your Organisation has reached the total allowed number of organization users. Please contact Administrator for further help.',
  CUSTOMER_USER_LIMIT_EXPIRES:
    'Your Organisation has reached the total allowed number of customer users. Please contact Administrator for further help.',
  CONFIG_ROLE_LIMIT_EXPIRES:
    'Your Organisation has reached the total allowed number of system roles. Please contact Administrator for further help.',
  PROJECT_ROLE_LIMIT_EXPIRES:
    'Your Organisation has reached the total allowed number of project roles. Please contact Administrator for further help.',
  NEED_TO_ADD_CARD: 'Please Add any of the Payment Method to Proceed',
}

export const STATIC_ALERT_A = [
  {
    messageContent:
      'Your Organisation has reached the total allowed number of projects. Please contact Administrator for further help.',
  },
  {
    messageContent:
      'Your Organisation has reached the total allowed number of organization users. Please contact Administrator for further help.',
  },
]

export const DYNAMIC_RESPONSES = {
  PROJECT_ADD: (project) => {
    const { name = '' } = project || {}
    return `${name} has been added.`
  },
  PROJECT_UPDATE: (project) => {
    const { name = '' } = project || {}
    return `${name} information has been updated.`
  },
  PROJECT_DELETE: (project) => {
    const { name = '' } = project || {}
    return `${name} has been successfully deleted.`
  },
}

export const TEXTS = {
  DELETE_WARNING: 'Once you delete this, it cannot be recovered.',
  COPY_WARNING: 'Once you copy this templated, you can use.',
  IMAGE_DELETE: 'Are you sure want to delete Image?',
  SOME_THING_WRONG: 'Something went wrong!',

  CUSTOMER_DELETE: 'Do you want to delete this customer?',
  CUSTOMER_DEACTIVATE: 'Do you want to deactivate this customer?',
  CUSTOMER_ACTIVATE: 'Do you want this customer to activate?',
  USER_DEACTIVATE: 'Do you want to deactivate this user?',
  USER_ACTIVATE: 'Do you want this user to activate?',
  USER_DELETE: 'Do you want to delete this user?',
  USER_REMOVE: 'Do you want to remove this user?',
  USER_PASSWORD_RESEND: 'Do you want to resend the password?',
  PROJECT_DELETE: 'Do you want to delete this project?',
  PROJECT_REPORT_SEND_ENABLE:
    'Are you sure you want to enable daily status report?',
  PROJECT_REPORT_SEND_DISABLE:
    'Are you sure you want to disable daily status report?',
  PROJECT_DEACTIVATE: 'Do you want this project to deactivate?',
  SPACE_DELETE: 'Do you want to delete this space?',
  SPACE_BULK_SAVE: 'Do you want to proceed?',
  TASK_DELETE: 'Do you want to delete this task?',
  EQUIPMENT_DELETE: 'Do you want to delete this equipment?',
  LOGOUT: 'Logout',
  LOGOUT_WARNING: 'Are you sure want to logout?',
  MEDIACENTRIC_USER_DELETE: `Are you sure want to delete ${MAIN_TITLE_TEXT?.PORTAL_NAME} user?`,
  ACTION_ITEM_DELETE: 'Do you want to delete this action item?',
  COMMENT_DELETE: 'Do you want to delete this comment?',
  NOTE_DELETE: 'Do you want to delete this note?',
  LINE_ITEM_DELETE: `Are you sure want to delete line item?`,
  TAG_DELETE: `Are you sure you want to delete this tag?`,
  LINE_ITEMS_DELETE: `Are you sure want to delete selected line items?`,
  TAGS_DELETE: `Are you sure want to delete selected Tags?`,

  PERMISSION_DENIED: `You do not have permission to access this resource.`,
  TEAM_MEMBER_DELETE: 'Do you want to remove this member from the team?',
  TEAM_MEMBER_WARNING:
    'This user cannot be deleted as it is must to have at least one user in the list. Please add one or more user in order to delete this one.',
  PROJECT_ONSITE_LEAD_ASSIGN:
    'Are you sure you want to make this user as an Onsite Lead?',
  PROJECT_ONSITE_LEAD_REMOVE:
    'Are you sure you want to remove this user from Onsite Lead?',
  FOLDER_DELETE: 'Do you want to delete this folder?',
  DOCUMENT_DELETE: 'Do you want to delete this document?',
  SPACE_TEMPLATE_DELETE: 'Do you want to delete this space template?',
  COPY_SPACE_TEMPLATE: 'Are you sure you want to create this space template?',

  WIDGET_PERMISSION_ERROR_TEXT: 'You do not have permission to view this data.',
  DEFAULT_PAGE_PERMISSION_ERROR_TEXT:
    'You do not have permission to view this data.',
  PERMISSION_DELETE_ERROR: 'You do not have a permission to delete.',
  PERMISSION_ERROR: 'Please allow permission to get notifications.',
  PERMISSION_WARNING: 'Missing Primary Permission',
  NOTIFICATION_ERROR: 'The setup for notifications has not been completed.',

  TASK_DELETE_IN_SPACE_TEMPLATE:
    'Do you want to delete this task in this space template?',
  TASK_TEMPLATE_CREATE: 'Are you sure you want to create this task template?',
  TASK_TEMPLATE_DELETE: 'Do you want to delete this task template?',
  TOKEN_SUCCESSFULLY_RECEIVED: 'Token has been received successfully.',
  ROLE_DELETE: 'Do you want to delete this role?',
  PERMISSION_DELETE: 'Do you want to delete this permission?',
  TASK_GROUP_DELETE: 'Do you want to delete this task group?',
  TASK_GROUP_DELETE_SPACE:
    'Do you want to delete this task group from the space?',
  TASK_TYPE_DELETE: 'Do you want to delete this task type?',
  TASK_SUB_TYPE_DELETE: 'Do you want to delete this task sub type?',
  BULK_TASK_DELETE: 'Do you want to delete this selected tasks?',
  TASK_STATUS_CHANGE: 'Task status change',
  TASK_STATUS_IMAGES_NOTE:
    'You are going to change the status of this task to be completed, please upload images first if you want to upload more.',
  TASK_STATUS_IMAGE_REQUIRE:
    'This task requires at least one image to be marked as completed.',
  TASK_IMAGE_DELETE: 'Task image delete',
  TASK_IMAGE_DELETE_NOTE:
    'The current status of this task is completed, needs at least one image to be in it.',
  TASK_GROUP: 'Task Group',
  TASK_COMPLETE_MULTIPLE:
    'It seems the following tasks need at least one image to be attached before mark as completed',
  TASK_GROUP_WARNING:
    'Please make sure there is at least 1 task added in the newly created task group, otherwise it will be removed once you leave the page.',
  PASSWORD_POLICY_TEXT:
    'Password must contain 1 uppercase letter, 1 lower case letter, 1 digit, 1 special character and minimum 8 characters.',
  ORGANIZATION_REMOVE: 'Do you want to remove this organization?',
  ORGANIZATION_DEACTIVATE: 'Do you want to deactivate this organization?',
  ORGANIZATION_ACTIVATE: 'Do you want this organization to activate?',

  SUBSCRIPTION_CANCEL: 'Are you sure you want to cancel subscription?',
  SUBSCRIPTION_WARING:
    'Once you cancel subscription, organization will be deactivated.',
  SUBSCRIPTION_CANCEL_REQ_DELETE:
    'Are you sure you want to delete cancel subscription request?',
  SUBSCRIPTION_WARING_REQ_DELETE:
    'Once you delete cancel subscription request, organization will be activated.',
  SUBSCRIPTION_REQUEST_HAS_CANCELLED:
    'Your request for subscription cancellation has been recieved',
  SUBSCRIPTION_PLAN_ISNOT_ACTIVE: "You don't have any active subscription",
  SUBSCRIPTION_PLAN_GRASS_TIME:
    'Your Subscription Payment Failed. You will lose your subscription if we don’t have working payment information in your account. Please',
  SUBSCRIPTION_USER_LIMIT_CHANGE: 'Do you want to change user limit?',
  SUBSCRIPTION_PLAN_UPGRADE: 'Do you want to upgrade subscription plan?',
  SUBSCRIPTION_PALN_DOWNGRADE: 'Do you want to downgrade subscription plan?',
  SUBSCRIPTION_PLAN_SAME: 'Welcome back! Are you ready to renew your',
  SUBSCRIPTION_PLAN_ALERT:
    'At this point you cannot change your user count. You can increase or decrease after renewal. If you have any questions, we are here to help. Contact us at info@projectcentric.net',
  SUBSCRIPTION_PLAN_WITH_USER: 'Are you sure with users limit is',
  SUBSCRIPTION_PLAN_VIEW: 'Frequent changes in plan is not allowed.',
  SUBSCRIPTION_PLAN_VIEW_BODY: 'You are not able to change the plan till',
  DELETE_LOGO: 'Do you want to delete this logo?',
  DELETE_PROFILE: 'Do you want to delete profile image?',
  RESEND_INVITATION: 'Do you want to resend invitation to user?',
  RETRY_PAYMENT: 'Do you want to retry payment?',
  DUPLICATE_FILE: 'Are you sure you want to duplicate ',
  DELETE_BULK_FILE: 'Are you sure you want to delete ',
  ANTIVIRUS_SCANNER: 'Are you sure you want to change antivirus status?',
  ONSITE_LEAD_ENABLE: 'Are you sure you want to enable Onsite lead override?',
  ONSITE_LEAD_DISABLE: 'Are you sure you want to disable Onsite lead override?',
  NO_VIEW_ALL_PERMISSION:
    'You do not have reporting permission to access this. Please contact your admin to provide you access.',
  SUBSCRIPTION_LINE_ITEM_LIMIT:
    'You cannot add more than 10 Budget Line Items under your plan.',
  RESELLER_DELETE: `Are you sure want to delete this reseller?`,
  RESELLER_ACTIVATE: `Are you sure want to Activate this reseller?`,
  RESELLER_DEACTIVATE: `Are you sure want to Deactivate this reseller?`,
  TAG_EXIST: `You already have a tag with that name!`,
  TAG_MERGE: `Do you want to merge them?`,
  DAILY_REPORT_DELETE: `Are you sure want to delete this daily report?`,
  ORGANIZATION_EXTEND_BILLING:
    'Are you sure you want to extend billing date of this organization?',
}

export const BUTTON_NAME = {
  IMAGE_UPLOAD_ERROR_BTN: 'Upload Not Allowed',
}

export const COOKIES_KEY = {
  DEVICE_TOKEN: 'device_token',
}

export const COOKIE_SET_TIMER = 604800

export const DEFAULT_PER_PAGE_RECORD = 10
export const DASHBOARD_RECORD_LIMIT = 5
export const MEDIACENTRIC_ORG = 1
export const DEFAULT_PAGE_START = 1

export const SPLIT_CONTENT_LIMIT = 120 // in characters

export const PAGE_LIMIT_FOR_TASKLIST = 0

export const TOP_RECORDS_LIMIT = 10

export const STATIC_COLOR = '#dc8e00'

export const PATTERN = {
  NAME: /^[A-Za-z- ,’'.`~"]+$/,
  PHONE_EXTENSION: /^([0-9]|x|)+$/,
  ALPHA_SPACE: /^[a-zA-Z ]+$/,
  CITY_PATTERN: /^[a-zA-Z ;,.\/\\'!:~`&-]+$/,
  AT_LEAST_ONE_LOWER_CASE: /[a-z]+/,
  AT_LEAST_ONE_UPPER_CASE: /[A-Z]+/,
  AT_LEAST_ONE_DIGIT: /[0-9]+/,
  AT_LEAST_ONE_SPECIAL_CHARACTER: /[\W]+/,
  PHONE_NUMBER:
    /^[\+]?[\0-9]{2,3}?[-\s\.]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{2,4}[-\s\.]*[0-9]{2,4}[-\s\.]*[0-9]{0,2}?[-\s\.]*[0-9]{0,2}?$/,
  HTML_TAG_IGNORE: /(<([^>]+)>)/gi,
  HREF: /href=("|')(.*?)("|')/g,
  EMAIL: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
  FOLDER_NAME: /^([a-zA-Z0-9][^#%&+]+)$/,
  // FOLDER_NAME:
  //   /^[a-zA-Z0-9!@$()-|\_-`.,/-`.,/“”"' ? * :~^_=}[]{1,}(?: [a-zA-Z0-9!@$&()\ | \ #%&+ ]+){0,2}$/,
  NAME_WITHOUT_FIRST_SPACE: /\s*\S+.*/,
  NAME_WITHOUT_SPACE:
    /^[a-zA-Z0-9!@#$&()\_-`.+,/]{1,}(?: [a-zA-Z0-9!@#$&()\ | \ -`.+,/“”" ? * :~%^_=}[ ]+){0,2}$/,
}

export const FILE_KEYS = ['Image', 'Document', 'Pdf', 'Other']

export const API_CONSTANTS = {
  REPORTING_ACTION_OPEN: 1,
  REPORTING_ACTION_OVERDUE: 3,
  REPORTING_ACTION_COMPLETED: 2,
  REPORTING_DELAY_MIN: 1,
  PROJECT_DASHBOARD_IN_PROGRESS: 2,
  CANCELED_ACTION_ITEM_STATUS_CODE: 4,
  SPACES_STATUSES: { open: 'In progress', finished: 'Completed' },
  STATUS_COUNT_TO_FINISH: ['completed'], //, 'canceled'],
  OTHERS_FEEDBACK: 'Other',
  TASK_COMPLETE_STATUS_CODE: 4,
  SUPER_ADMIN_ROLE_ID: 1,
  OVERDUE_ACTION_ITEM_STATUS_CODE: 3,
  COMPLETED_ACTION_ITEM_STATUS_CODE: 2,
  OVERDUE_ACTION_ITEM_COLOR: '#ff4d4a',
  OVERDUE_ACTION_ITEM_TEXT: 'Overdue',
}

export const FREQUENT_TEXT_CANGE = {
  ACTIVATE: 'Activate',
  DEACTIVATE: 'Deactivate',
  CANCELLATION_PENDING: 'Pending cancel',
  INACTIVE: 'Inactive',
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
  REMOVE: 'Remove',
  DELETE: 'Delete',
}

export const KEY_CODES = {
  ENTER_KEY: 13,
}

export const VALIDATE_STATUS = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'Success',
}

export const ERROR_CODE = {
  MENUAL_CODE: 405,
}

export const SORTING_TYPE = {
  ASC: 'ASC',
  DESC: 'DESC',
  DEFAULT: 'DEFAULT',
}

export const USERS_TYPE = [
  { id: 0, name: 'Organization User', value: false },
  { id: 1, name: 'Customer User', value: true },
]

export const ROLE_TYPE = {
  PLATFORM_OWNER: 0,
  SUPER_ADMIN: 1,
  ADMIN: 2,
  PLATFORM_ADMIN: 2,
}

export const ROLE_TEXT = {
  ADMIN: 'Admin',
}

export const COMMAN_STATUS = {
  REMOVE: 'removed',
}

export const ACTION_ITEM_STATUS = {
  OPEN: 1,
  COMPLETED: 2,
}

export const SPACE_STATUS = {
  COMPLETED: 0,
  IN_PROGRESS: 1,
  OPEN: 2,
  ON_HOLD: 3,
  CANCELLED: 4,
}

export const PROJECT_STATUS = {
  All: 0,
  OPEN: 1,
  IN_PROGRESS: 2,
  ON_HOLD: 3,
  CANCELLED: 5,
  COMPLETED: 4,
}

export const PROJECT_TITLE = {
  0: {
    prefix: 'Projects',
    postfix: 'Project',
  },
  1: {
    prefix: 'Open',
    postfix: 'Open',
  },
  2: {
    prefix: 'In Progress',
    postfix: 'In Progress',
  },
  3: {
    prefix: 'On Hold',
    postfix: 'On Hold',
  },
  4: {
    prefix: 'Completed',
    postfix: 'Completed',
  },
  5: {
    prefix: 'Canceled',
    postfix: 'Canceled',
  },
  6: {
    prefix: 'Draft',
    postfix: 'Draft',
  },
}

export const IS_IMAGE_REQUIRED = [
  { id: 0, name: 'Required', value: true },
  { id: 1, name: 'Not required', value: false },
]

export const SPACE_EXPORT_CATEGORY = [
  {
    id: 0,
    name: 'Tasks',
    value: 'includeTaskList',
    checked: true,
  },
  {
    id: 1,
    name: 'Equipment',
    value: 'includeDeviceList',
    checked: false,
  },
]

export const ORGANIZATION_STATUS = [
  {
    id: 0,
    name: 'Active',
    value: true,
  },
  {
    id: 1,
    name: 'Inactive',
    value: false,
  },
]

export const USER_INVITATION_STATUS = [
  {
    id: 0,
    name: 'Accepted',
    value: true,
  },
  {
    id: 1,
    name: 'Pending',
    value: false,
  },
]

export const CHANGE_SUPER_ADMIN_STATUS = [
  {
    id: 1,
    name: 'Deactivate',
    value: 1,
  },
  {
    id: 2,
    name: 'Delete',
    value: 2,
  },
  {
    id: 3,
    name: 'Do Nothing',
    value: 3,
  },
]

export const OUT_OF_SCOPE = [
  {
    id: 1,
    name: 'YES',
    value: true,
  },
  {
    id: 2,
    name: 'NO',
    value: false,
  },
]

// Question Type DropDown FAQ
export const QUESTION_AUDIENCE_TYPE = [
  {
    id: 1,
    name: 'Organization',
    value: 'organization',
  },
  {
    id: 2,
    name: 'Customer',
    value: 'customer',
  },
  {
    id: 3,
    name: 'Both',
    value: 'both',
  },
]

export const CONFIG_PERMISSIONS = {
  USER: 1,
  PROJECT: 2,
  TEMPLATE: 3,
  ROLE: 4,
  CUSTOMER: 5,
  REPORTING: 6,
  ACTION_ITEM: 7,
  COMMENT: 8,
  TASK_GROUPS: 9,
  FEEDBACK: 10,
  DASHBOARD: 11,
  PROJECT_DOCUMENT: 12,
  CUSTOMER_DOCUMENT: 13,
  PROJECT_SPACE: 14,
  PROJECT_SPACE_TASK: 15,
  PROJECT_SPACE_TASK_IMAGE: 16,
  PROJECT_ROLE: 17,
  PROJECT_NOTE: 18,
  PROJECT_ALL: 19,
  BUDGET_CONFIGURATION: 20,
  PROJECT_BUDGET: 21,
  PROJECT_BUDGET_BUDGETED: 22,
  PROJECT_BUDGET_USED: 23,
  PROJECT_BUDGET_SCHEDULED: 24,
  TAG_CONFIGURATION: 25,
}

export const PERMISSIONS_TEXT = {
  1: 'User',
  2: 'Project',
  3: 'Template',
  4: 'Role',
  5: 'Customer',
  6: 'Reporting',
  7: 'Action Item',
  8: 'Comment',
  9: 'Task Groups',
  10: 'FeedBack',
  11: 'Dashboard',
  12: 'Project Document',
  13: 'Customer Document',
  14: 'Space',
  15: 'Task',
  16: 'Task Image',
  17: 'Project Role',
  18: 'Project Notes',
  19: 'Project All',
  20: 'Budget Configuration',
  21: 'Project Budget',
  22: 'Project Budget Budgeted',
  23: 'Project Budget Used',
  24: 'Project Budget Scheduled',
}

export const ONBOARDING_WIZARD = {
  ON_START: 1,
  ON_COMPLETED: 6,
  TC: 'terms&condition',
  TIMEZONE: 'timezone',
  PLAN: 'plan',
  PAYMENT_SETUP: 'paymentsetup',
  MANAGE_PEOPLE: 'managepeople',
  FAQ: 'faq',
}

export const PLAN_TYPE = {
  DEMO_PLAN: 1,
}

export const DISCOUNT_TYPE = {
  AMOUNT: 'amount',
  PERCENTAGE: 'percentage',
}

export const PAYMENT_TYPE = {
  CARD: 'CreditCard',
  VAULT: 'PayPalAccount',
}

export const MODAL_BUTTON_TEXT = {
  PLAN_UPGRADE: 'Upgrade Plan',
}

export const SUBSCRIPTION_PLAN_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive', // if subscription expired
  FAILED: 'failed', // if cron is going to renew plan from backend then if payment failed
  END: 'end', // remove all the data from databse
  PAYMENT_DUE: 'paymentDue', // payment due on payment
}

export const PORTAL_RESTRICTION = {
  NOT_ACCESS: 0, // Only profile will visible of super admin
  ACCESS: 1, // Allow feaures to access ( including grass period )
}

export const SUBSCRIPTION_PLAN_KEYS = {
  MIN_USERS: 5,
  CAN_ALLOW: -1, // user are allow to access
  CAN_NOT_ALLOW: -2, // user are not allow to access
  UNLIMITED: 'unlimited', // user have unlimited access
  UNLIMITED_YES: 'yes', // user have unlimited access
}

// Subscription limit key name from Permission
export const SUBSCRIPTION_LIMIT_KEYS = {
  CUSTOMER_USER: 'customerUser',
  PROJECT: 'project',
  PROJECT_ROLE: 'projectRole',
  PROJECT_YEARLY: 'projectYearly',
  ROLE: 'role',
  STORAGE: 'storage',
  ORGANIZATION_USER: 'userCount',
  CONFIG_BUDGET_LINE_ITEM: 'configBudgetLineItem',
}

// Subscription Plan limit key name from plan listing
export const PLAN_LIMIT_KEYS = {
  CUSTOMER_USER: 'customerUsers',
  PROJECT: 'numberOfProjectsInPlatform',
  PROJECT_YEARLY: 'numberOfProjectsPerYear',
  PROJECT_ROLE: 'projectRoles',
  ROLE: 'systemRoles',
  STORAGE: 'storageSpace',
  ORGANIZATION_MAX_USER: 'maximumUser',
  CONFIG_BUDGET_LINE_ITEM: 'configBudgetLineItem',
}

// subscription name key with Permission opration ID
export const SUBSCRIPTION_CONFIG_WITH_PERMISSION = {
  ACTIONITEMS: 7, // action item
  COMMENTS: 8, // comments
  DASHBOARD: 11, //dashboard
  INTERNALNOTES: 18, // internal notes
  PROJECTROLES: 17, // project roles
  SYSTEMROLES: 4, // project roles
  REPORTINGTAB: 6, // reporting tabs
  SPACESPERPROJECT: 14, // project space
  TASKPERSPACE: 15, // project space task
  PROJECT_DOCUMENT: 12, // project attachment
  CUSTOMER_DOCUMENT: 13, // customer attachment
  PROJECT_SPACE_TASK_IMAGE: 16, // project task attachment
  BUDGET: 20,
}

// ACTIONITEMS: action item
// AUTOMATEDDAILYREPORTING: not use
// COMMENTS: comments
// DAILYREPORTREADYTOSENDFEATURE: Daily report ready to send feature
// DASHBOARD: dashboard
// DOCUMENTATIONREPOSITORY: documention repository all the attachment
// EQUIPMENTASSETSCANNINGVIAMOBILE: not use
// EXPORT: export
// IMPORT: import
// INTERNALNOTES:internal notes
// MOBILEAPPFORTECHS: configration for role
// MULTIPLETAGS: project tags
// OFFLINEMODE: not use
// OUTOFSCOPECOMMENTSCHECKBOX: comment ourt of scope
// PERSONALIZEDBRANDING: logo
// PROJECTCOMPLETIONREPORT: not use
// PROJECTROLES: project roles
// PROJECTSNAPSHOTREPORT: project snapshorts
// REPORTINGTAB: Reporting
// SPACESPERPROJECT: proejct space
// SYSTEMROLES: configraton roles
// TASKPERSPACE: Project space task
// TEAMASSIGNMENTS: team page
// USERMOBILEAPP: not use

export const FILE_SOURCE_STORE_TYPE = {
  DIRECTORY: 'directory',
  FILE: 'file',
}

export const FOLDER_NAME = {
  SPACE_TEMPLATE_ADD_FOLDER: '',
}

export const MODAL_TEXT = {
  ADD_FOLDER_MODAL_NAME: 'Create Folder',
  UPDATE_FOLDER_NAME: 'Rename Folder',
  ADD_FOLDER_BUTTON: 'Add Folder',
  UPDATE_FOLDER_BUTTON: 'Update Folder',
}

export const TOOL_TIP_TEXT = {
  EXPORT_DATA: 'Download/Print data in file types: CSV, PDF, XLSX',
  SPACE_CART: 'View each space in large card-style format.',
  SPACE_LIST: 'View each space in small list-style format.',
  SPACE_SEARCH_BAR: 'Spaces can be searched by name.',
  SPACE_SELECT_ALL: 'Select all/select none function can be toggled here.',
}

export const PROJECT_STATUS_TOOL_TIP = {
  0: {
    STATUS: 'All',
    TOOL_TIP_TEXT: 'Amount of tasks assigned to the current project.',
  },
  1: {
    STATUS: 'OPEN',
    TOOL_TIP_TEXT: 'Amount of individual tasks not started.',
  },
  2: {
    STATUS: 'IN_PROGRESS',
    TOOL_TIP_TEXT: 'Amount of individual tasks in progress.',
  },
  3: {
    STATUS: 'ON_HOLD',
    TOOL_TIP_TEXT: 'Amount of individual tasks on hold.',
  },
  4: {
    STATUS: 'COMPLETED',
    TOOL_TIP_TEXT: 'Amount of individual tasks completed.',
  },
  5: {
    STATUS: 'CANCELED',
    TOOL_TIP_TEXT: 'Number of individual canceled tasks.',
  },
}

export const PROJECT_TASK_STATUS = {
  ON_HOLD: 3,
  COMPLETED: 4,
  CANCELLED: 5,
}

export const IMPORT_SAMPLES = {
  PROJECTS_SAMPLE:
    'https://importsamples.s3.amazonaws.com/Project%2BImport.xlsx',
  USERS_SAMPLE: 'https://importsamples.s3.amazonaws.com/User%2BImport.xlsx',
  SPACE_WITH_TASK_SAMPLE:
    'https://importsamples.s3.amazonaws.com/Space%2BImport.xlsx',
  TASKS_SAMPLE: 'https://importsamples.s3.amazonaws.com/Task%2BImport.xlsx',
  EQUIPMENTS_SAMPLE:
    'https://importsamples.s3.amazonaws.com/Device%2BImport.xlsx',
  CUSTOMERS_WITH_USERS_SAMPLE:
    'https://importsamples.s3.amazonaws.com/Customer%2BUser.xlsx',
  TASKS_TEMPLATE: 'https://importsamples.s3.amazonaws.com/Task_Template.xlsx',
  SPACE_TEMPLATE: 'https://importsamples.s3.amazonaws.com/Space_Template.xlsx',
  SPACE_TEMPLATE_WITH_EQUIPMENT:
    'https://importsamples.s3.amazonaws.com/Space%2BDevice%2BImport.xlsx',
  CONFIG_BUDGET:
    'https://importsamples.s3.amazonaws.com/Config%2BLine%2BItem.xlsx',
}

export const ELEMENT_FORMAT = {
  DATE_FORMAT: 'MM/DD/YYYY',
  DATE_FORMAT_MONTH: 'MM/YY',
  TIME_DATE_FORMAT: 'hh:mm a MM/DD/YYYY',
}

export const notAllowedFile = [
  'application/octet-stream',
  'application/x-ms-dos-executable',
]

// application/octet-stream' &&
//       'application/x-ms-dos-executable' &&
//       'application/x-authorware-bin' &&
//       'application/x-authorware-map' &&
//       'application/x-authorware-seg' &&
//       'application/postscript' &&
//       'application/x-aim' &&
//       'application/x-navi-animation' &&
//       'application/x-nokia-9000-communicator-add-on-software' &&
//       'application/mime' &&
//       'application/octet-stream' &&
//       'application/arj' &&
//       'application/octet-stream' &&
//       'application/x-mplayer2' &&
//       'application/x-troff-msvideo' &&
//       'application/x-bcpio' &&
//       'application/mac-binary' &&
//       'application/macbinary' &&
//       'application/x-binary' &&
//       'application/x-macbinary' &&
//       'application/book' &&
//       'application/book' &&
//       'application/x-bzip2' &&
//       'application/x-bsh' &&
//       'application/x-bzip' &&
//       'application/x-bzip2' &&
//       'application/vnd.ms-pki.seccat' &&
//       'application/clariscad' &&
//       'application/x-cocoa' &&
//       'application/cdf' &&
//       'application/x-cdf' &&
//       'application/x-netcdf' &&
//       'application/pkix-cert' &&
//       'application/x-x509-ca-cert' &&
//       'application/x-chat' &&
//       'application/x-chat' &&
//       'application/java' &&
//       'application/java-byte-code' &&
//       'application/x-java-class' &&
//       'application/octet-stream'
